import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, debounceTime } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AssessmentSummaryDTO, GaitAnalysisViewModel, StringViewModel, GaitAnalysisSummaryViewModel, CreateAssessmentDTO, AssessmentProgramCategoryViewModel, AssessmentTooltipViewModelRead, AssessmentTooltipViewModel, AssessmentListViewModelRead, AssessmentDetailViewModel, AssessmentViewModelRead, LoadingLevelsAssessmentViewModelRead, LoadingLevelsAssessmentViewModel, LoadingLevelsProgramDisplayViewModel, AssessmentNotesViewModel, AssessmentNotesViewModelRead, AssessmentType, TwoDimensionalAssessmentViewModelRead, TwoDimensionalAssessmentViewModel, TwoDimensionalAssessmentProgramDisplayViewModel, AFFitnessAssessmentViewModelRead, AFFitnessAssessmentViewModel, BrandViewModelRead, ClientSummaryDTO, ClientSearchParams, UserSummaryViewModel, UserCoachViewModel, UserAuthenticationViewModel, ClientDetailsViewModelRead, ClientDashboardCombinedViewModelRead, AddRunnerViewModel, ClientProgramWorkoutDayViewModelRead, ClientProgramWorkoutDayViewModel, CalendarWeekViewModel, CalendarDayViewModel, WorkoutDisplayExtendedViewModelRead, WorkoutItemDisplayDetailsViewModelRead, QuickWorkoutDisplayViewModelRead, ClientProgramWorkoutViewModel, ClientProgramWorkoutCombinedViewModel, ClientProgramWorkoutDayItemViewModelRead, ClientProgramWorkoutDayItemViewModel, ClientAddWorkoutMessageViewModel, ClientAddWorkoutNoteViewModel, ClientProgramWorkoutJournalViewModel, ClientFinishWorkoutViewModel, ClientProgramListViewModel, ClientProgramViewModelRead, DailyStatusListViewModel, DailyStatusViewModelRead, DailyStatusViewModel, ClientProgramWorkoutDayEditViewModel, ClientWorkoutViewModelRead, ClientWorkoutViewModel, ClientWorkoutByCategoryViewModelRead, ClientExerciseViewModelRead, ClientExerciseViewModel, LevelChangeClientExerciseViewModel, ExerciseViewModelReadWithProgressionInfo, ClientUpdateWorkoutRPEViewModel, ClientUpdateWorkoutDurationsViewModel, ClientUpdateWorkoutExerciseProgressesViewModel, CalendarEventViewModel, CopyCalendarWeekViewModel, UserCredentialJournalEntryViewModelRead, UserCredentialJournalEntryViewModel, UserCredentialCombinedJournalViewModel, UserCredentialCombinedJournalSearchParams, ExerciseListViewModelRead, ExerciseSearchParams, ExerciseViewModelRead, ExerciseViewModel, ExerciseTagViewModelRead, WorkoutListViewModelRead, WorkoutSummaryViewModelRead, WorkoutSearchParams, WorkoutViewModelRead, WorkoutViewModel, AzureBlobSASViewModel, WorkoutDisplayViewModelRead, WorkoutDisplayParams, WorkoutKeywordViewModelRead, WorkoutProgressionListViewModelRead, WorkoutProgressionSearchParams, WorkoutProgressionViewModelRead, WorkoutProgressionViewModel, ExerciseProgressionListViewModelRead, ExerciseProgressionSearchParams, ExerciseProgressionViewModelRead, ExerciseProgressionViewModel, ExternalDailyChartData, ExternalWorkoutSummaryViewModelRead, ExternalWorkoutChartData, ExternalWorkoutPaceChartData, ExternalWorkoutLapChartData, MessageViewModel, SendMessageViewModel, UserProfileViewModel, OrganizationViewModelRead, PricingTierViewModel, OrganizationViewModel, OrganizationBillingViewModel, CreatePaymentMethodViewModel, CreateSubscriptionViewModel, OrganizationListViewModelRead, CreateOrganizationViewModel, OrganizationRegistrationViewModel, OrganizationSearchParams, OrganizationInvoiceViewModel, OrganizationSubscriptionViewModel, ReinstateOrgTrialViewModel, StripeConnectedAccountBalanceViewModel, PromoCodeViewModelRead, ProgramSummaryViewModelRead, ProgramKeywordViewModelRead, ProgramListViewModelRead, ProgramSearchParams, PurchasePaidProgramViewModel, AddPaidProgramRunnerViewModel, ProgramSummaryViewModelReadExtended, GlobalMarketplaceProgramListViewModelRead, GlobalPaidProgramsSearchParams, ProgramViewModelRead, ProgramViewModel, ProgramAssignmentViewModel, TeamProgramViewModelRead, ProgramTeamAssignmentViewModel, AssessmentProgramAssignmentViewModel, MovementCategoryProgramViewModelRead, ImpairmentCategoryProgramViewModelRead, LoadingLevelsProgramViewModelRead, LoadingLevelsProgramAssignmentViewModel, TwoDimensionalProgramAssignmentViewModel, ImpairmentCategoryUpdateViewModel, CoachAthleteGroupViewModel, DynamicReportViewModel, DynamicReportFilterViewModel, TrainingVolumeReportViewModel, ChartViewModel, TrainingLoadTargetViewModelRead, CoachDashboardViewModel, AcuteChronicHistoryViewModel, UserCredentialStatIntensityByActivityTypeViewModelRead, StravaDeauthorizeResponse, TeamListViewModelRead, TeamSummaryViewModelRead, TeamDetailsViewModelRead, TeamAddViewModel, TeamEditViewModel, TeamUserRole, TeamProgramWorkoutDayViewModelRead, TeamProgramWorkoutDayViewModel, TeamProgramWorkoutDayEditViewModel, TeamDashboardViewModel, TeamProgramListViewModel, TermsAndConditionsViewModelRead, UserAuthProfileViewModel, UpdateProfileViewModel, UpdateProfileWithPasswordViewModel, UserLookupViewModel, UserLookupInputViewModel, ChangePasswordViewModel, ResetPasswordViewModel, AddUserViewModel, UpdateUserViewModel, UpdateUserRoleViewModel, BooleanViewModel, VideoViewModelRead, VideoViewModel, UserCredentialNotificationViewModelRead, NotificationTypeRoleViewModelRead, RacePlanViewModelRead, RacePlanListViewModelRead, RacePlanViewModel, UserSearchResultViewModel, UserSearchParams, SuperuserStatsViewModel, SimpleDynamicReportViewModel, SurveyViewModelRead, SurveySummaryViewModelRead, SurveyQuestionSummaryViewModelRead, SurveyResultViewModelRead, SurveyResultSummaryViewModelRead, SurveyResultSearchParams, SurveySummaryViewModel, SurveyQuestionSummaryViewModel, SurveyResponseViewModel, SurveyResultViewModel, TrainingLoadPlannerViewModelRead, TrainingLoadPlannerListViewModelRead, TrainingLoadPeriodViewModelRead, TrainingLoadPlannerViewModel } from '../_models/generatedModels';
import { SettingsProvider } from './settingsProvider.service';
import { PagedResult } from '../_models/models';

@Injectable()
export class AssessmentService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getAssessmentSummariesForUser(userId: number): Observable<AssessmentSummaryDTO[]> {
       return this.http.get<AssessmentSummaryDTO[]>(`${this.baseUrl}/users/${userId}/assessments`);
   }

  getSpecificGaitAnalysis(analysisId: number): Observable<GaitAnalysisViewModel> {
       return this.http.get<GaitAnalysisViewModel>(`${this.baseUrl}/users/gait-analysis/${analysisId}`);
   }

  getSpecificGaitAnalysisByGuid(model: StringViewModel): Observable<GaitAnalysisViewModel> {
       return this.http.post<GaitAnalysisViewModel>(`${this.baseUrl}/users/gait-analysis-by-guid`, model)
            .pipe(map((result: GaitAnalysisViewModel) => result));
  }

  getGaitAnalysisSummaryById(analysisId: number): Observable<GaitAnalysisSummaryViewModel> {
       return this.http.get<GaitAnalysisSummaryViewModel>(`${this.baseUrl}/users/gait-analysis/${analysisId}/summary`);
   }

  getGaitAnalysisSummariesForUser(): Observable<GaitAnalysisViewModel[]> {
       return this.http.get<GaitAnalysisViewModel[]>(`${this.baseUrl}/users/gait-analysis`);
   }

  createAssessment(userId: number, isDraft: boolean, model: CreateAssessmentDTO): Observable<AssessmentSummaryDTO> {
       if (isDraft == null){
       return this.http.post<AssessmentSummaryDTO>(`${this.baseUrl}/users/${userId}/assessments`, model)
            .pipe(map((result: AssessmentSummaryDTO) => result));
  } else{
       return this.http.post<AssessmentSummaryDTO>(`${this.baseUrl}/users/${userId}/assessments?isDraft=${isDraft}`, model)
            .pipe(map((result: AssessmentSummaryDTO) => result));
  }
  }

  updateAssessment(assessmentId: number, isDraft: boolean, model: CreateAssessmentDTO): Observable<AssessmentSummaryDTO> {
       if (isDraft == null){
       return this.http.put<AssessmentSummaryDTO>(`${this.baseUrl}/assessments/rra/${assessmentId}`, model)
            .pipe(map((result: AssessmentSummaryDTO) => result));
  } else{
       return this.http.put<AssessmentSummaryDTO>(`${this.baseUrl}/assessments/rra/${assessmentId}?isDraft=${isDraft}`, model)
            .pipe(map((result: AssessmentSummaryDTO) => result));
  }
  }

  getAssessmentCategoryProgramInfoById(assessmentId: number): Observable<AssessmentProgramCategoryViewModel> {
       return this.http.get<AssessmentProgramCategoryViewModel>(`${this.baseUrl}/assessments/${assessmentId}/programCategory`);
   }

  getAssessmentTooltips(): Observable<AssessmentTooltipViewModelRead[]> {
       return this.http.get<AssessmentTooltipViewModelRead[]>(`${this.baseUrl}/assessments/tooltips`);
   }

  getAssessmentTooltipById(assessmentTooltipId: number): Observable<AssessmentTooltipViewModelRead> {
       return this.http.get<AssessmentTooltipViewModelRead>(`${this.baseUrl}/assessments/tooltips/${assessmentTooltipId}`);
   }

  getAssessmentTooltipByKey(assessmentTooltipKey: string): Observable<AssessmentTooltipViewModelRead> {
       return this.http.get<AssessmentTooltipViewModelRead>(`${this.baseUrl}/assessments/tooltips/key/${assessmentTooltipKey}`);
   }

  updateAssessmentTooltip(assessmentTooltipId: number, model: AssessmentTooltipViewModel): Observable<AssessmentTooltipViewModelRead> {
       return this.http.put<AssessmentTooltipViewModelRead>(`${this.baseUrl}/assessments/tooltips/${assessmentTooltipId}`, model)
            .pipe(map((result: AssessmentTooltipViewModelRead) => result));
  }

  getAllAssessmentsForUser(userId: number): Observable<AssessmentListViewModelRead[]> {
       return this.http.get<AssessmentListViewModelRead[]>(`${this.baseUrl}/users/${userId}/assessments/all`);
   }

  getAssessmentDetails(assessmentId: number): Observable<AssessmentDetailViewModel> {
       return this.http.get<AssessmentDetailViewModel>(`${this.baseUrl}/assessments/${assessmentId}/details`);
   }

  getAssessmentById(userId: number, assessmentId: number): Observable<AssessmentViewModelRead> {
       return this.http.get<AssessmentViewModelRead>(`${this.baseUrl}/users/${userId}/assessments/${assessmentId}`);
   }

  createLoadingLevelsAssessment(userId: number, isDraft: boolean, model: LoadingLevelsAssessmentViewModel): Observable<LoadingLevelsAssessmentViewModelRead> {
       if (isDraft == null){
       return this.http.post<LoadingLevelsAssessmentViewModelRead>(`${this.baseUrl}/users/${userId}/loadingLevelsAssessments`, model)
            .pipe(map((result: LoadingLevelsAssessmentViewModelRead) => result));
  } else{
       return this.http.post<LoadingLevelsAssessmentViewModelRead>(`${this.baseUrl}/users/${userId}/loadingLevelsAssessments?isDraft=${isDraft}`, model)
            .pipe(map((result: LoadingLevelsAssessmentViewModelRead) => result));
  }
  }

  updateLoadingLevelsAssessment(loadingLevelsAssessmentId: number, isDraft: boolean, model: LoadingLevelsAssessmentViewModel): Observable<LoadingLevelsAssessmentViewModelRead> {
       if (isDraft == null){
       return this.http.put<LoadingLevelsAssessmentViewModelRead>(`${this.baseUrl}/assessments/loadingLevels/${loadingLevelsAssessmentId}`, model)
            .pipe(map((result: LoadingLevelsAssessmentViewModelRead) => result));
  } else{
       return this.http.put<LoadingLevelsAssessmentViewModelRead>(`${this.baseUrl}/assessments/loadingLevels/${loadingLevelsAssessmentId}?isDraft=${isDraft}`, model)
            .pipe(map((result: LoadingLevelsAssessmentViewModelRead) => result));
  }
  }

  getLoadingLevelsAssessment(loadingLevelsAssessmentId: number): Observable<LoadingLevelsAssessmentViewModelRead> {
       return this.http.get<LoadingLevelsAssessmentViewModelRead>(`${this.baseUrl}/assessments/loadingLevels/${loadingLevelsAssessmentId}`);
   }

  getLoadingLevelsAssessmentProgramInfoById(loadingLevelsAssessmentId: number): Observable<LoadingLevelsProgramDisplayViewModel> {
       return this.http.get<LoadingLevelsProgramDisplayViewModel>(`${this.baseUrl}/assessments/loadingLevels/${loadingLevelsAssessmentId}/program`);
   }

  updateAssessmentNotes(model: AssessmentNotesViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/assessments/notes`, model)
            .pipe(map((result: boolean) => result));
  }

  getAssessmentNotes(assessmentId: number, assessmentType: AssessmentType): Observable<AssessmentNotesViewModelRead> {
       if (assessmentType == null){
       return this.http.get<AssessmentNotesViewModelRead>(`${this.baseUrl}/assessments/${assessmentId}/notes`);
   } else{
       return this.http.get<AssessmentNotesViewModelRead>(`${this.baseUrl}/assessments/${assessmentId}/notes?assessmentType=${assessmentType}`);
   }
  }

  updateGaitAnalysis(assessmentId: number, model: GaitAnalysisSummaryViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/assessments/gait-analysis/${assessmentId}`, model)
            .pipe(map((result: boolean) => result));
  }

  createTwoDimensionalAssessment(userId: number, isDraft: boolean, model: TwoDimensionalAssessmentViewModel): Observable<TwoDimensionalAssessmentViewModelRead> {
       if (isDraft == null){
       return this.http.post<TwoDimensionalAssessmentViewModelRead>(`${this.baseUrl}/users/${userId}/twoDimensionalAssessments`, model)
            .pipe(map((result: TwoDimensionalAssessmentViewModelRead) => result));
  } else{
       return this.http.post<TwoDimensionalAssessmentViewModelRead>(`${this.baseUrl}/users/${userId}/twoDimensionalAssessments?isDraft=${isDraft}`, model)
            .pipe(map((result: TwoDimensionalAssessmentViewModelRead) => result));
  }
  }

  updateTwoDimensionalAssessment(twoDimensionalAssessmentId: number, isDraft: boolean, model: TwoDimensionalAssessmentViewModel): Observable<TwoDimensionalAssessmentViewModelRead> {
       if (isDraft == null){
       return this.http.put<TwoDimensionalAssessmentViewModelRead>(`${this.baseUrl}/assessments/twoDimensionalAssessments/${twoDimensionalAssessmentId}`, model)
            .pipe(map((result: TwoDimensionalAssessmentViewModelRead) => result));
  } else{
       return this.http.put<TwoDimensionalAssessmentViewModelRead>(`${this.baseUrl}/assessments/twoDimensionalAssessments/${twoDimensionalAssessmentId}?isDraft=${isDraft}`, model)
            .pipe(map((result: TwoDimensionalAssessmentViewModelRead) => result));
  }
  }

  getTwoDimensionalAssessment(twoDimensionalAssessmentId: number): Observable<TwoDimensionalAssessmentViewModelRead> {
       return this.http.get<TwoDimensionalAssessmentViewModelRead>(`${this.baseUrl}/assessments/twoDimensionalAssessments/${twoDimensionalAssessmentId}`);
   }

  getTwoDimensionalAssessmentProgramInfoById(twoDimensionalAssessmentId: number): Observable<TwoDimensionalAssessmentProgramDisplayViewModel> {
       return this.http.get<TwoDimensionalAssessmentProgramDisplayViewModel>(`${this.baseUrl}/assessments/twoDimensionalAssessments/${twoDimensionalAssessmentId}/program`);
   }

  createAFFitnessAssessment(userId: number, model: AFFitnessAssessmentViewModel): Observable<AFFitnessAssessmentViewModelRead> {
       return this.http.post<AFFitnessAssessmentViewModelRead>(`${this.baseUrl}/users/${userId}/afFitnessAssessments`, model)
            .pipe(map((result: AFFitnessAssessmentViewModelRead) => result));
  }

  getAFFitnessAssessment(afFitnessAssessmentId: number): Observable<AFFitnessAssessmentViewModelRead> {
       return this.http.get<AFFitnessAssessmentViewModelRead>(`${this.baseUrl}/assessments/afFitnessAssessments/${afFitnessAssessmentId}`);
   }

  deleteAssessment(assessmentId: number, assessmentType: AssessmentType): Observable<boolean> {
       if (assessmentType == null){
       return this.http.delete<boolean>(`${this.baseUrl}/assessments/${assessmentId}/delete`);
   } else{
       return this.http.delete<boolean>(`${this.baseUrl}/assessments/${assessmentId}/delete?assessmentType=${assessmentType}`);
   }
  }

}
@Injectable()
export class BrandService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getBrandByKeyName(keyName: string): Observable<BrandViewModelRead> {
       if (keyName == null){
       return this.http.get<BrandViewModelRead>(`${this.baseUrl}/brands/keyName`);
   } else{
       return this.http.get<BrandViewModelRead>(`${this.baseUrl}/brands/keyName?keyName=${keyName}`);
   }
  }

  getBrandById(brandId: number): Observable<BrandViewModelRead> {
       return this.http.get<BrandViewModelRead>(`${this.baseUrl}/brands/${brandId}`);
   }

}
@Injectable()
export class ClientsService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getActiveClients(): Observable<ClientSummaryDTO[]> {
       return this.http.get<ClientSummaryDTO[]>(`${this.baseUrl}/users/clients`);
   }

  getActiveClientsForUser(userId: number): Observable<ClientSummaryDTO[]> {
       return this.http.get<ClientSummaryDTO[]>(`${this.baseUrl}/users/clients/byUser/${userId}`);
   }

  getActiveUsersForUser(userId: number): Observable<ClientSummaryDTO[]> {
       return this.http.get<ClientSummaryDTO[]>(`${this.baseUrl}/users/clients/usersByUser/${userId}`);
   }

  searchClients(userId: number, searchParams: ClientSearchParams): Observable<PagedResult<ClientSummaryDTO>> {
       return this.http.post<PagedResult<ClientSummaryDTO>>(`${this.baseUrl}/users/clients/search/${userId}`, searchParams)
            .pipe(map((result: PagedResult<ClientSummaryDTO>) => result));
  }

  getClientByID(clientUserId: number): Observable<UserSummaryViewModel> {
       return this.http.get<UserSummaryViewModel>(`${this.baseUrl}/users/clients/${clientUserId}`);
   }

  getClientByEmail(email: string): Observable<UserSummaryViewModel> {
       if (email == null){
       return this.http.get<UserSummaryViewModel>(`${this.baseUrl}/users/clients/email`);
   } else{
       return this.http.get<UserSummaryViewModel>(`${this.baseUrl}/users/clients/email?email=${email}`);
   }
  }

  getClientCoachInfoById(clientUserId: number): Observable<UserCoachViewModel> {
       return this.http.get<UserCoachViewModel>(`${this.baseUrl}/users/clients/${clientUserId}/coachInfo`);
   }

  activateClient(clientUserId: number, isCoachedOnly: boolean): Observable<UserAuthenticationViewModel> {
       if (isCoachedOnly == null){
       return this.http.post<UserAuthenticationViewModel>(`${this.baseUrl}/users/clients/${clientUserId}/activate`, null)
            .pipe(map((result: UserAuthenticationViewModel) => result));
  } else{
       return this.http.post<UserAuthenticationViewModel>(`${this.baseUrl}/users/clients/${clientUserId}/activate?isCoachedOnly=${isCoachedOnly}`, null)
            .pipe(map((result: UserAuthenticationViewModel) => result));
  }
  }

  deactivateClient(clientUserId: number): Observable<UserAuthenticationViewModel> {
       return this.http.post<UserAuthenticationViewModel>(`${this.baseUrl}/users/clients/${clientUserId}/deactivate`, null)
            .pipe(map((result: UserAuthenticationViewModel) => result));
  }

  getClientDetailsByID(clientUserId: number): Observable<ClientDetailsViewModelRead> {
       return this.http.get<ClientDetailsViewModelRead>(`${this.baseUrl}/users/clients/${clientUserId}/details`);
   }

  getClientDashboardCombinedData(clientUserId: number, localCurrentDate: Date, acwrPageSize: number): Observable<ClientDashboardCombinedViewModelRead> {
       if (localCurrentDate == null && acwrPageSize == null){
       return this.http.get<ClientDashboardCombinedViewModelRead>(`${this.baseUrl}/users/clients/${clientUserId}/dashboard`);
   } else{
       return this.http.get<ClientDashboardCombinedViewModelRead>(`${this.baseUrl}/users/clients/${clientUserId}/dashboard?localCurrentDate=${localCurrentDate.toISOString()}&acwrPageSize=${acwrPageSize}`);
   }
  }

  addNewClient(model: AddRunnerViewModel): Observable<ClientSummaryDTO> {
       return this.http.post<ClientSummaryDTO>(`${this.baseUrl}/clients/`, model)
            .pipe(map((result: ClientSummaryDTO) => result));
  }

  getClientProgramWorkoutDayById(clientUserId: number, clientProgramWorkoutDayId: number): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.get<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/${clientUserId}/workoutDays/${clientProgramWorkoutDayId}`);
   }

  addClientProgramWorkoutDay(clientUserId: number, model: ClientProgramWorkoutDayViewModel): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.post<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/${clientUserId}/workoutDays`, model)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }

  updateClientProgramWorkoutDay(clientUserId: number, workoutDayId: number, model: ClientProgramWorkoutDayViewModel): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/${clientUserId}/workoutDays/${workoutDayId}`, model)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }

  deleteClientProgramWorkoutDay(clientUserId: number, workoutDayId: number, deleteSeries: boolean): Observable<boolean> {
       if (deleteSeries == null){
       return this.http.delete<boolean>(`${this.baseUrl}/clients/${clientUserId}/workoutDays/${workoutDayId}`);
   } else{
       return this.http.delete<boolean>(`${this.baseUrl}/clients/${clientUserId}/workoutDays/${workoutDayId}?deleteSeries=${deleteSeries}`);
   }
  }

  getClientCalendarWeeks(clientUserId: number, selectedDate: Date, localCurrentDate: Date, isMonthView: boolean, isCoachView: boolean): Observable<CalendarWeekViewModel[]> {
       if (selectedDate == null && localCurrentDate == null && isMonthView == null && isCoachView == null){
       return this.http.get<CalendarWeekViewModel[]>(`${this.baseUrl}/clients/${clientUserId}/calendarWeeks`);
   } else{
       return this.http.get<CalendarWeekViewModel[]>(`${this.baseUrl}/clients/${clientUserId}/calendarWeeks?selectedDate=${selectedDate.toISOString()}&localCurrentDate=${localCurrentDate.toISOString()}&isMonthView=${isMonthView}&isCoachView=${isCoachView}`);
   }
  }

  getClientCalendarWeeksByDateRange(clientUserId: number, startDate: Date, endDate: Date, localCurrentDate: Date): Observable<CalendarWeekViewModel[]> {
       if (startDate == null && endDate == null && localCurrentDate == null){
       return this.http.get<CalendarWeekViewModel[]>(`${this.baseUrl}/clients/${clientUserId}/calendarWeeksByDateRange`);
   } else{
       return this.http.get<CalendarWeekViewModel[]>(`${this.baseUrl}/clients/${clientUserId}/calendarWeeksByDateRange?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&localCurrentDate=${localCurrentDate.toISOString()}`);
   }
  }

  getClientCalendarDaysByDateRange(clientUserCredentialId: number, startDate: Date, endDate: Date, isCoachView: boolean): Observable<CalendarDayViewModel[]> {
       if (startDate == null && endDate == null && isCoachView == null){
       return this.http.get<CalendarDayViewModel[]>(`${this.baseUrl}/clients/userCredentials/${clientUserCredentialId}/calendarDays`);
   } else{
       return this.http.get<CalendarDayViewModel[]>(`${this.baseUrl}/clients/userCredentials/${clientUserCredentialId}/calendarDays?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&isCoachView=${isCoachView}`);
   }
  }

  getClientWorkoutsWithDisplayDetails(clientUserId: number, startDate: Date, endDate: Date): Observable<WorkoutDisplayExtendedViewModelRead[]> {
       if (startDate == null && endDate == null){
       return this.http.get<WorkoutDisplayExtendedViewModelRead[]>(`${this.baseUrl}/clients/users/${clientUserId}/clientWorkoutDisplayDetails`);
   } else{
       return this.http.get<WorkoutDisplayExtendedViewModelRead[]>(`${this.baseUrl}/clients/users/${clientUserId}/clientWorkoutDisplayDetails?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`);
   }
  }

  getClientWorkoutItemExerciseDisplayDetails(clientProgramWorkoutDayId: number, workoutItemId: number, workoutItemExerciseId: number, selectedExerciseId: number, exerciseProgressSortOrder: number): Observable<WorkoutItemDisplayDetailsViewModelRead> {
       if (workoutItemId == null && workoutItemExerciseId == null && selectedExerciseId == null && exerciseProgressSortOrder == null){
       return this.http.get<WorkoutItemDisplayDetailsViewModelRead>(`${this.baseUrl}/clients/clientProgramWorkoutDays/${clientProgramWorkoutDayId}/clientWorkoutitemExerciseDisplayDetails`);
   } else{
       return this.http.get<WorkoutItemDisplayDetailsViewModelRead>(`${this.baseUrl}/clients/clientProgramWorkoutDays/${clientProgramWorkoutDayId}/clientWorkoutitemExerciseDisplayDetails?workoutItemId=${workoutItemId}&workoutItemExerciseId=${workoutItemExerciseId}&selectedExerciseId=${selectedExerciseId}&exerciseProgressSortOrder=${exerciseProgressSortOrder}`);
   }
  }

  getClientQuickWorkoutsWithDisplayDetails(clientUserId: number, startDate: Date, endDate: Date): Observable<QuickWorkoutDisplayViewModelRead[]> {
       if (startDate == null && endDate == null){
       return this.http.get<QuickWorkoutDisplayViewModelRead[]>(`${this.baseUrl}/clients/users/${clientUserId}/clientQuickWorkoutDisplayDetails`);
   } else{
       return this.http.get<QuickWorkoutDisplayViewModelRead[]>(`${this.baseUrl}/clients/users/${clientUserId}/clientQuickWorkoutDisplayDetails?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`);
   }
  }

  getClientProgramWorkoutDetails(clientProgramWorkoutDayId: number): Observable<ClientProgramWorkoutViewModel> {
       return this.http.get<ClientProgramWorkoutViewModel>(`${this.baseUrl}/clients/clientProgramWorkoutDays/${clientProgramWorkoutDayId}`);
   }

  getClientProgramWorkoutCombinedDetails(clientProgramWorkoutDayId: number): Observable<ClientProgramWorkoutCombinedViewModel> {
       return this.http.get<ClientProgramWorkoutCombinedViewModel>(`${this.baseUrl}/clients/clientProgramWorkoutDays/${clientProgramWorkoutDayId}/combined`);
   }

  addUpdateClientProgramWorkoutDayItem(model: ClientProgramWorkoutDayItemViewModel): Observable<ClientProgramWorkoutDayItemViewModelRead> {
       return this.http.post<ClientProgramWorkoutDayItemViewModelRead>(`${this.baseUrl}/clients/workoutDays`, model)
            .pipe(map((result: ClientProgramWorkoutDayItemViewModelRead) => result));
  }

  addClientProgramWorkoutDayMessage(workoutDayId: number, model: ClientAddWorkoutMessageViewModel): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.post<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/message`, model)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }

  addClientProgramWorkoutDayNote(workoutDayId: number, model: ClientAddWorkoutNoteViewModel): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.post<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/note`, model)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }

  getWorkoutJournalsForClientProgramWorkoutDayId(workoutDayId: number): Observable<ClientProgramWorkoutJournalViewModel[]> {
       return this.http.get<ClientProgramWorkoutJournalViewModel[]>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/journal`);
   }

  updateClientProgramWorkoutDayDate(workoutDayId: number, updatedDate: Date): Observable<ClientProgramWorkoutDayViewModelRead> {
       if (updatedDate == null){
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/date`, null)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  } else{
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/date?updatedDate=${updatedDate.toISOString()}`, null)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }
  }

  updateClientProgramWorkoutDayIsCompleted(workoutDayId: number, model: ClientFinishWorkoutViewModel): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/isCompleted`, model)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }

  getCurrentProgramsForClient(clientUserId: number): Observable<ClientProgramListViewModel[]> {
       return this.http.get<ClientProgramListViewModel[]>(`${this.baseUrl}/clients/${clientUserId}/programs`);
   }

  deleteClientProgram(clientProgramId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/clients/programs/${clientProgramId}`);
   }

  rescheduleClientProgram(clientProgramId: number, startDate: Date, weekNumber: number): Observable<ClientProgramViewModelRead> {
       if (startDate == null && weekNumber == null){
       return this.http.put<ClientProgramViewModelRead>(`${this.baseUrl}/clients/programs/${clientProgramId}/reschedule`, null)
            .pipe(map((result: ClientProgramViewModelRead) => result));
  } else{
       return this.http.put<ClientProgramViewModelRead>(`${this.baseUrl}/clients/programs/${clientProgramId}/reschedule?startDate=${startDate.toISOString()}&weekNumber=${weekNumber}`, null)
            .pipe(map((result: ClientProgramViewModelRead) => result));
  }
  }

  getRecentDailyStatusesForUser(clientUserId: number): Observable<DailyStatusListViewModel[]> {
       return this.http.get<DailyStatusListViewModel[]>(`${this.baseUrl}/clients/${clientUserId}/dailyStatuses/recent`);
   }

  getDailyStatus(dailyStatusId: number): Observable<DailyStatusViewModelRead> {
       return this.http.get<DailyStatusViewModelRead>(`${this.baseUrl}/clients/dailyStatuses/${dailyStatusId}`);
   }

  doesUserHaveDailyStatusToday(clientUserId: number, timeZoneOffset: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/clients/${clientUserId}/dailyStatuses/today/${timeZoneOffset}`);
   }

  addDailyStatus(clientUserId: number, model: DailyStatusViewModel): Observable<DailyStatusViewModelRead> {
       return this.http.post<DailyStatusViewModelRead>(`${this.baseUrl}/clients/${clientUserId}/dailyStatuses`, model)
            .pipe(map((result: DailyStatusViewModelRead) => result));
  }

  updateClientProgramWorkoutDayOccurrence(workoutDayId: number, model: ClientProgramWorkoutDayEditViewModel): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/editOccurrence`, model)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }

  addUpdateClientWorkout(model: ClientWorkoutViewModel): Observable<ClientWorkoutViewModelRead> {
       return this.http.post<ClientWorkoutViewModelRead>(`${this.baseUrl}/clients/clientWorkouts`, model)
            .pipe(map((result: ClientWorkoutViewModelRead) => result));
  }

  getClientWorkoutsByCategory(clientUserId: number): Observable<ClientWorkoutByCategoryViewModelRead[]> {
       return this.http.get<ClientWorkoutByCategoryViewModelRead[]>(`${this.baseUrl}/clients/${clientUserId}/clientWorkouts`);
   }

  deleteClientWorkout(clientUserId: number, workoutId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/${clientUserId}/clientWorkouts/${workoutId}`);
   }

  addUpdateClientExercise(model: ClientExerciseViewModel): Observable<ClientExerciseViewModelRead> {
       return this.http.post<ClientExerciseViewModelRead>(`${this.baseUrl}/clients/clientExercises`, model)
            .pipe(map((result: ClientExerciseViewModelRead) => result));
  }

  levelChangeClientExercise(model: LevelChangeClientExerciseViewModel): Observable<ClientExerciseViewModelRead> {
       return this.http.post<ClientExerciseViewModelRead>(`${this.baseUrl}/clients/clientExercises/levelChange`, model)
            .pipe(map((result: ClientExerciseViewModelRead) => result));
  }

  getClientExercises(clientUserId: number): Observable<ExerciseViewModelReadWithProgressionInfo[]> {
       return this.http.get<ExerciseViewModelReadWithProgressionInfo[]>(`${this.baseUrl}/clients/${clientUserId}/clientExercises`);
   }

  deleteClientExercise(clientUserId: number, exerciseId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/${clientUserId}/clientExercises/${exerciseId}`);
   }

  isRPERequiredForClientProgramWorkoutDay(workoutDayId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/rpeRequired`);
   }

  updateClientProgramWorkoutDayRPE(workoutDayId: number, model: ClientUpdateWorkoutRPEViewModel): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/RPE`, model)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }

  updateClientProgramWorkoutDayActivityTypeDurations(workoutDayId: number, model: ClientUpdateWorkoutDurationsViewModel): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/durations`, model)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }

  updateClientProgramWorkoutDayExerciseProgresses(workoutDayId: number, model: ClientUpdateWorkoutExerciseProgressesViewModel): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/exerciseProgresses`, model)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }

  getDailyStatusesForClient(clientUserId: number, page: number, size: number): Observable<PagedResult<DailyStatusListViewModel>> {
       if (page == null && size == null){
       return this.http.get<PagedResult<DailyStatusListViewModel>>(`${this.baseUrl}/clients/${clientUserId}/dailyStatuses`);
   } else{
       return this.http.get<PagedResult<DailyStatusListViewModel>>(`${this.baseUrl}/clients/${clientUserId}/dailyStatuses?page=${page}&size=${size}`);
   }
  }

  unmatchClientProgramWorkoutDay(workoutDayId: number): Observable<ClientProgramWorkoutDayViewModelRead> {
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/unmatch`, null)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }

  getMatchableClientProgramWorkoutDays(garminActivityId: number, stravaActivityId: number): Observable<CalendarEventViewModel[]> {
       if (garminActivityId == null && stravaActivityId == null){
       return this.http.get<CalendarEventViewModel[]>(`${this.baseUrl}/clients/workoutDays/matchablecalendarEvents`);
   } else{
       return this.http.get<CalendarEventViewModel[]>(`${this.baseUrl}/clients/workoutDays/matchablecalendarEvents?garminActivityId=${garminActivityId}&stravaActivityId=${stravaActivityId}`);
   }
  }

  matchClientProgramWorkoutDay(workoutDayId: number, syncedClientProgramWorkoutId: number, ratePerceivedExertion: number): Observable<ClientProgramWorkoutDayViewModelRead> {
       if (syncedClientProgramWorkoutId == null && ratePerceivedExertion == null){
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/match`, null)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  } else{
       return this.http.put<ClientProgramWorkoutDayViewModelRead>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/match?syncedClientProgramWorkoutId=${syncedClientProgramWorkoutId}&ratePerceivedExertion=${ratePerceivedExertion}`, null)
            .pipe(map((result: ClientProgramWorkoutDayViewModelRead) => result));
  }
  }

  makeClientProgramWorkoutDayLevelChanges(clientUserId: number, workoutDayId: number, newWorkoutId: number): Observable<boolean> {
       if (newWorkoutId == null){
       return this.http.put<boolean>(`${this.baseUrl}/clients/${clientUserId}/workoutDays/${workoutDayId}/levelChanges`, null)
            .pipe(map((result: boolean) => result));
  } else{
       return this.http.put<boolean>(`${this.baseUrl}/clients/${clientUserId}/workoutDays/${workoutDayId}/levelChanges?newWorkoutId=${newWorkoutId}`, null)
            .pipe(map((result: boolean) => result));
  }
  }

  resendRunnerWelcomeEmail(clientUserId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/clients/${clientUserId}/resendRunnerWelcomeEmail`, null)
            .pipe(map((result: boolean) => result));
  }

  makeUserCredentialWorkoutExerciseChanges(userCredentialId: number, workoutId: number, defaultExerciseId: number, selectedExerciseId: number): Observable<boolean> {
       if (userCredentialId == null && workoutId == null && defaultExerciseId == null && selectedExerciseId == null){
       return this.http.put<boolean>(`${this.baseUrl}/clients/userCredentialWorkoutExercise`, null)
            .pipe(map((result: boolean) => result));
  } else{
       return this.http.put<boolean>(`${this.baseUrl}/clients/userCredentialWorkoutExercise?userCredentialId=${userCredentialId}&workoutId=${workoutId}&defaultExerciseId=${defaultExerciseId}&selectedExerciseId=${selectedExerciseId}`, null)
            .pipe(map((result: boolean) => result));
  }
  }

  addClientWorkoutDayExerciseProgresses(clientProgramWorkoutDayId: number, model: any[]): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/clients/workoutDays/${clientProgramWorkoutDayId}/addExerciseProgresses`, model)
            .pipe(map((result: boolean) => result));
  }

  copyClientCalendarWeek(clientUserId: number, model: CopyCalendarWeekViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/clients/${clientUserId}/copyCalendarWeek`, model)
            .pipe(map((result: boolean) => result));
  }

  updateClientProgramWorkoutDaySyncedWorkoutName(workoutDayId: number, model: StringViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/clients/workoutDays/${workoutDayId}/updateSyncedWorkoutName`, model)
            .pipe(map((result: boolean) => result));
  }

  addUserCredentialJournalEntry(userId: number, model: UserCredentialJournalEntryViewModel): Observable<UserCredentialJournalEntryViewModelRead> {
       return this.http.post<UserCredentialJournalEntryViewModelRead>(`${this.baseUrl}/clients/${userId}/journalEntry`, model)
            .pipe(map((result: UserCredentialJournalEntryViewModelRead) => result));
  }

  searchCombinedJournalEntries(userId: number, searchParams: UserCredentialCombinedJournalSearchParams): Observable<UserCredentialCombinedJournalViewModel[]> {
       return this.http.post<UserCredentialCombinedJournalViewModel[]>(`${this.baseUrl}/users/clients/searchCombinedJournalEntries/${userId}`, searchParams)
            .pipe(map((result: UserCredentialCombinedJournalViewModel[]) => result));
  }

}
@Injectable()
export class ExerciseService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getExercisesForOrganization(page: number, size: number, sortProperty: string, isSortDesc: boolean): Observable<PagedResult<ExerciseListViewModelRead>> {
       if (page == null && size == null && sortProperty == null && isSortDesc == null){
       return this.http.get<PagedResult<ExerciseListViewModelRead>>(`${this.baseUrl}/exercises`);
   } else{
       return this.http.get<PagedResult<ExerciseListViewModelRead>>(`${this.baseUrl}/exercises?page=${page}&size=${size}&sortProperty=${sortProperty}&isSortDesc=${isSortDesc}`);
   }
  }

  getAllExercisesForOrganization(): Observable<ExerciseListViewModelRead[]> {
       return this.http.get<ExerciseListViewModelRead[]>(`${this.baseUrl}/exercises/all`);
   }

  searchForExercises(searchParams: ExerciseSearchParams): Observable<PagedResult<ExerciseListViewModelRead>> {
       return this.http.post<PagedResult<ExerciseListViewModelRead>>(`${this.baseUrl}/exercises/search`, searchParams)
            .pipe(map((result: PagedResult<ExerciseListViewModelRead>) => result));
  }

  getExerciseById(exerciseId: number): Observable<ExerciseViewModelRead> {
       return this.http.get<ExerciseViewModelRead>(`${this.baseUrl}/exercises/${exerciseId}`);
   }

  addExercise(model: ExerciseViewModel): Observable<ExerciseViewModelRead> {
       return this.http.post<ExerciseViewModelRead>(`${this.baseUrl}/exercises`, model)
            .pipe(map((result: ExerciseViewModelRead) => result));
  }

  updateExercise(exerciseId: number, model: ExerciseViewModel): Observable<ExerciseViewModelRead> {
       return this.http.put<ExerciseViewModelRead>(`${this.baseUrl}/exercises/${exerciseId}`, model)
            .pipe(map((result: ExerciseViewModelRead) => result));
  }

  deleteExercise(exerciseId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/exercises/${exerciseId}`);
   }

  getExerciseTagsForOrganization(): Observable<ExerciseTagViewModelRead[]> {
       return this.http.get<ExerciseTagViewModelRead[]>(`${this.baseUrl}/exerciseTags`);
   }

  getWorkoutsForOrganization(page: number, size: number, sortProperty: string, isSortDesc: boolean): Observable<PagedResult<WorkoutListViewModelRead>> {
       if (page == null && size == null && sortProperty == null && isSortDesc == null){
       return this.http.get<PagedResult<WorkoutListViewModelRead>>(`${this.baseUrl}/workouts`);
   } else{
       return this.http.get<PagedResult<WorkoutListViewModelRead>>(`${this.baseUrl}/workouts?page=${page}&size=${size}&sortProperty=${sortProperty}&isSortDesc=${isSortDesc}`);
   }
  }

  getAllWorkoutsForOrganization(): Observable<WorkoutSummaryViewModelRead[]> {
       return this.http.get<WorkoutSummaryViewModelRead[]>(`${this.baseUrl}/workouts/all`);
   }

  searchForWorkouts(searchParams: WorkoutSearchParams): Observable<PagedResult<WorkoutListViewModelRead>> {
       return this.http.post<PagedResult<WorkoutListViewModelRead>>(`${this.baseUrl}/workouts/search`, searchParams)
            .pipe(map((result: PagedResult<WorkoutListViewModelRead>) => result));
  }

  getWorkoutById(workoutId: number): Observable<WorkoutViewModelRead> {
       return this.http.get<WorkoutViewModelRead>(`${this.baseUrl}/workouts/${workoutId}`);
   }

  addWorkout(model: WorkoutViewModel): Observable<WorkoutViewModelRead> {
       return this.http.post<WorkoutViewModelRead>(`${this.baseUrl}/workouts`, model)
            .pipe(map((result: WorkoutViewModelRead) => result));
  }

  updateWorkout(workoutId: number, model: WorkoutViewModel): Observable<WorkoutViewModelRead> {
       return this.http.put<WorkoutViewModelRead>(`${this.baseUrl}/workouts/${workoutId}`, model)
            .pipe(map((result: WorkoutViewModelRead) => result));
  }

  deleteWorkout(workoutId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/workouts/${workoutId}`);
   }

  updateWorkoutExpectedDurations(model: WorkoutViewModel): Observable<WorkoutViewModel> {
       return this.http.put<WorkoutViewModel>(`${this.baseUrl}/workouts/durationUpdate`, model)
            .pipe(map((result: WorkoutViewModel) => result));
  }

  cloneWorkout(userId: number, workoutId: number): Observable<WorkoutViewModelRead> {
       if (userId == null && workoutId == null){
       return this.http.post<WorkoutViewModelRead>(`${this.baseUrl}/workouts/clone`, null)
            .pipe(map((result: WorkoutViewModelRead) => result));
  } else{
       return this.http.post<WorkoutViewModelRead>(`${this.baseUrl}/workouts/clone?userId=${userId}&workoutId=${workoutId}`, null)
            .pipe(map((result: WorkoutViewModelRead) => result));
  }
  }

  isExerciseNameDuplicate(name: string, existingId: number): Observable<boolean> {
       if (name == null && existingId == null){
       return this.http.get<boolean>(`${this.baseUrl}/exercises/duplicateName`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/exercises/duplicateName?name=${name}&existingId=${existingId}`);
   }
  }

  isWorkoutNameDuplicate(name: string, existingId: number): Observable<boolean> {
       if (name == null && existingId == null){
       return this.http.get<boolean>(`${this.baseUrl}/workouts/duplicateName`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/workouts/duplicateName?name=${name}&existingId=${existingId}`);
   }
  }

  getEquipmentListForExerciseIds(exerciseIds: any[]): Observable<string[]> {
       if (exerciseIds == null){
       return this.http.get<string[]>(`${this.baseUrl}/exercises/equipmentList`);
   } else{
       return this.http.get<string[]>(`${this.baseUrl}/exercises/equipmentList?exerciseIds=${exerciseIds}`);
   }
  }

  getSASForVideoContainer(model: StringViewModel): Observable<AzureBlobSASViewModel> {
       return this.http.post<AzureBlobSASViewModel>(`${this.baseUrl}/exercises/upload-sas`, model)
            .pipe(map((result: AzureBlobSASViewModel) => result));
  }

  getWorkoutDisplayDetails(model: WorkoutDisplayParams): Observable<WorkoutDisplayViewModelRead> {
       return this.http.post<WorkoutDisplayViewModelRead>(`${this.baseUrl}/workouts/display`, model)
            .pipe(map((result: WorkoutDisplayViewModelRead) => result));
  }

  cloneExercise(userId: number, exerciseId: number): Observable<ExerciseViewModelRead> {
       if (userId == null && exerciseId == null){
       return this.http.post<ExerciseViewModelRead>(`${this.baseUrl}/exercise/clone`, null)
            .pipe(map((result: ExerciseViewModelRead) => result));
  } else{
       return this.http.post<ExerciseViewModelRead>(`${this.baseUrl}/exercise/clone?userId=${userId}&exerciseId=${exerciseId}`, null)
            .pipe(map((result: ExerciseViewModelRead) => result));
  }
  }

  getWorkoutKeywordsForOrganization(): Observable<WorkoutKeywordViewModelRead[]> {
       return this.http.get<WorkoutKeywordViewModelRead[]>(`${this.baseUrl}/workouts/workoutKeywords`);
   }

  searchForWorkoutProgressions(searchParams: WorkoutProgressionSearchParams): Observable<PagedResult<WorkoutProgressionListViewModelRead>> {
       return this.http.post<PagedResult<WorkoutProgressionListViewModelRead>>(`${this.baseUrl}/workoutProgressions/search`, searchParams)
            .pipe(map((result: PagedResult<WorkoutProgressionListViewModelRead>) => result));
  }

  getWorkoutProgressionById(workoutProgressionId: number): Observable<WorkoutProgressionViewModelRead> {
       return this.http.get<WorkoutProgressionViewModelRead>(`${this.baseUrl}/workoutProgressions/${workoutProgressionId}`);
   }

  isWorkoutProgressionNameDuplicate(name: string, existingId: number): Observable<boolean> {
       if (name == null && existingId == null){
       return this.http.get<boolean>(`${this.baseUrl}/workoutProgressions/duplicateName`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/workoutProgressions/duplicateName?name=${name}&existingId=${existingId}`);
   }
  }

  addWorkoutProgression(model: WorkoutProgressionViewModel): Observable<WorkoutProgressionViewModelRead> {
       return this.http.post<WorkoutProgressionViewModelRead>(`${this.baseUrl}/workoutProgressions`, model)
            .pipe(map((result: WorkoutProgressionViewModelRead) => result));
  }

  updateWorkoutProgression(workoutProgressionId: number, model: WorkoutProgressionViewModel): Observable<WorkoutProgressionViewModelRead> {
       return this.http.put<WorkoutProgressionViewModelRead>(`${this.baseUrl}/workoutProgressions/${workoutProgressionId}`, model)
            .pipe(map((result: WorkoutProgressionViewModelRead) => result));
  }

  isWorkoutInAnotherProgression(workoutId: number, existingWorkoutProgressionId: number): Observable<boolean> {
       if (workoutId == null && existingWorkoutProgressionId == null){
       return this.http.get<boolean>(`${this.baseUrl}/workoutProgressions/duplicateWorkout`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/workoutProgressions/duplicateWorkout?workoutId=${workoutId}&existingWorkoutProgressionId=${existingWorkoutProgressionId}`);
   }
  }

  deleteWorkoutProgression(workoutProgressionId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/workoutProgressions/${workoutProgressionId}`);
   }

  searchForExerciseProgressions(searchParams: ExerciseProgressionSearchParams): Observable<PagedResult<ExerciseProgressionListViewModelRead>> {
       return this.http.post<PagedResult<ExerciseProgressionListViewModelRead>>(`${this.baseUrl}/exerciseProgressions/search`, searchParams)
            .pipe(map((result: PagedResult<ExerciseProgressionListViewModelRead>) => result));
  }

  getExerciseProgressionById(exerciseProgressionId: number): Observable<ExerciseProgressionViewModelRead> {
       return this.http.get<ExerciseProgressionViewModelRead>(`${this.baseUrl}/exerciseProgressions/${exerciseProgressionId}`);
   }

  isExerciseProgressionNameDuplicate(name: string, existingId: number): Observable<boolean> {
       if (name == null && existingId == null){
       return this.http.get<boolean>(`${this.baseUrl}/exerciseProgressions/duplicateName`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/exerciseProgressions/duplicateName?name=${name}&existingId=${existingId}`);
   }
  }

  addExerciseProgression(model: ExerciseProgressionViewModel): Observable<ExerciseProgressionViewModelRead> {
       return this.http.post<ExerciseProgressionViewModelRead>(`${this.baseUrl}/exerciseProgressions`, model)
            .pipe(map((result: ExerciseProgressionViewModelRead) => result));
  }

  updateExerciseProgression(exerciseProgressionId: number, model: ExerciseProgressionViewModel): Observable<ExerciseProgressionViewModelRead> {
       return this.http.put<ExerciseProgressionViewModelRead>(`${this.baseUrl}/exerciseProgressions/${exerciseProgressionId}`, model)
            .pipe(map((result: ExerciseProgressionViewModelRead) => result));
  }

  isExerciseInAnotherProgression(exerciseId: number, existingExerciseProgressionId: number): Observable<boolean> {
       if (exerciseId == null && existingExerciseProgressionId == null){
       return this.http.get<boolean>(`${this.baseUrl}/exerciseProgressions/duplicateExercise`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/exerciseProgressions/duplicateExercise?exerciseId=${exerciseId}&existingExerciseProgressionId=${existingExerciseProgressionId}`);
   }
  }

  deleteExerciseProgression(exerciseProgressionId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/exerciseProgressions/${exerciseProgressionId}`);
   }

  convertCardioWorkoutToGarmin(workoutId: number): Observable<WorkoutViewModelRead> {
       return this.http.put<WorkoutViewModelRead>(`${this.baseUrl}/workouts/${workoutId}/convertToGarmin`, null)
            .pipe(map((result: WorkoutViewModelRead) => result));
  }

}
@Injectable()
export class ExternalDailyService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getRestingHeartRateChartData(clientUserId: number): Observable<ExternalDailyChartData[]> {
       return this.http.get<ExternalDailyChartData[]>(`${this.baseUrl}/externalDaily/${clientUserId}/charts/restingHeartRate`);
   }

}
@Injectable()
export class ExternalWorkoutService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getExternalWorkoutSummary(clientProgramWorkoutDayId: number, isMetricSystem: boolean): Observable<ExternalWorkoutSummaryViewModelRead> {
       if (isMetricSystem == null){
       return this.http.get<ExternalWorkoutSummaryViewModelRead>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}`);
   } else{
       return this.http.get<ExternalWorkoutSummaryViewModelRead>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}?isMetricSystem=${isMetricSystem}`);
   }
  }

  getElevationChartData(clientProgramWorkoutDayId: number, isMetricSystem: boolean): Observable<ExternalWorkoutChartData[]> {
       if (isMetricSystem == null){
       return this.http.get<ExternalWorkoutChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/elevation`);
   } else{
       return this.http.get<ExternalWorkoutChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/elevation?isMetricSystem=${isMetricSystem}`);
   }
  }

  getHeartRateChartData(clientProgramWorkoutDayId: number): Observable<ExternalWorkoutChartData[]> {
       return this.http.get<ExternalWorkoutChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/heartRate`);
   }

  getCadenceChartData(clientProgramWorkoutDayId: number): Observable<ExternalWorkoutChartData[]> {
       return this.http.get<ExternalWorkoutChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/cadence`);
   }

  getPaceChartData(clientProgramWorkoutDayId: number, isMetricSystem: boolean): Observable<ExternalWorkoutPaceChartData[]> {
       if (isMetricSystem == null){
       return this.http.get<ExternalWorkoutPaceChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/pace`);
   } else{
       return this.http.get<ExternalWorkoutPaceChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/pace?isMetricSystem=${isMetricSystem}`);
   }
  }

  getStrideLengthChartData(clientProgramWorkoutDayId: number): Observable<ExternalWorkoutChartData[]> {
       return this.http.get<ExternalWorkoutChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/strideLength`);
   }

  getSpeedChartData(clientProgramWorkoutDayId: number, isMetricSystem: boolean): Observable<ExternalWorkoutChartData[]> {
       if (isMetricSystem == null){
       return this.http.get<ExternalWorkoutChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/speed`);
   } else{
       return this.http.get<ExternalWorkoutChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/speed?isMetricSystem=${isMetricSystem}`);
   }
  }

  getLapChartData(clientProgramWorkoutDayId: number, isMetricSystem: boolean): Observable<ExternalWorkoutLapChartData[]> {
       if (isMetricSystem == null){
       return this.http.get<ExternalWorkoutLapChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/laps`);
   } else{
       return this.http.get<ExternalWorkoutLapChartData[]>(`${this.baseUrl}/externalWorkout/${clientProgramWorkoutDayId}/charts/laps?isMetricSystem=${isMetricSystem}`);
   }
  }

}
@Injectable()
export class FileService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  addImage(model: StringViewModel): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/images`, model)
            .pipe(map((result: StringViewModel) => result));
  }

  getSASForFileContainer(filename: string, container: string): Observable<AzureBlobSASViewModel> {
       if (filename == null && container == null){
       return this.http.post<AzureBlobSASViewModel>(`${this.baseUrl}/azure-sas`, null)
            .pipe(map((result: AzureBlobSASViewModel) => result));
  } else{
       return this.http.post<AzureBlobSASViewModel>(`${this.baseUrl}/azure-sas?filename=${filename}&container=${container}`, null)
            .pipe(map((result: AzureBlobSASViewModel) => result));
  }
  }

}
@Injectable()
export class GarminService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  unlinkGarmin(): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/garmin/unlink-garmin`, null)
            .pipe(map((result: boolean) => result));
  }

  doesUserHaveGarminPermission(permissionType: string): Observable<boolean> {
       if (permissionType == null){
       return this.http.get<boolean>(`${this.baseUrl}/garmin/userPermission`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/garmin/userPermission?permissionType=${permissionType}`);
   }
  }

  createGarminTrainingWorkoutScheduleAndCheckForWorkout(workoutId: number, clientProgramWorkoutDayId: number): Observable<boolean> {
       if (workoutId == null && clientProgramWorkoutDayId == null){
       return this.http.post<boolean>(`${this.baseUrl}/garmin/trainingSchedule`, null)
            .pipe(map((result: boolean) => result));
  } else{
       return this.http.post<boolean>(`${this.baseUrl}/garmin/trainingSchedule?workoutId=${workoutId}&clientProgramWorkoutDayId=${clientProgramWorkoutDayId}`, null)
            .pipe(map((result: boolean) => result));
  }
  }

}
@Injectable()
export class MessagingService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getUnreadMessagesToUser(): Observable<MessageViewModel[]> {
       return this.http.get<MessageViewModel[]>(`${this.baseUrl}/messages/my-messages/unread`);
   }

  getMyMessages(filterBy: number): Observable<MessageViewModel[]> {
       if (filterBy == null){
       return this.http.get<MessageViewModel[]>(`${this.baseUrl}/messages/my-messages`);
   } else{
       return this.http.get<MessageViewModel[]>(`${this.baseUrl}/messages/my-messages?filterBy=${filterBy}`);
   }
  }

  sendMessage(model: SendMessageViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/messages/sendMessage`, model)
            .pipe(map((result: boolean) => result));
  }

  getUserFilterListForUserMessages(): Observable<ClientSummaryDTO[]> {
       return this.http.get<ClientSummaryDTO[]>(`${this.baseUrl}/messages/user-filter`);
   }

  getMessagesBetweenTwoUsers(clientUserId: number, mailboxFolderType: string): Observable<MessageViewModel[]> {
       if (mailboxFolderType == null){
       return this.http.get<MessageViewModel[]>(`${this.baseUrl}/messages/my-messages-from/${clientUserId}`);
   } else{
       return this.http.get<MessageViewModel[]>(`${this.baseUrl}/messages/my-messages-from/${clientUserId}?mailboxFolderType=${mailboxFolderType}`);
   }
  }

}
@Injectable()
export class OrganizationService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getOrgUsers(): Observable<UserProfileViewModel[]> {
       return this.http.get<UserProfileViewModel[]>(`${this.baseUrl}/organization/users`);
   }

  getOrgUsersByOrgId(organizationId: number): Observable<UserProfileViewModel[]> {
       return this.http.get<UserProfileViewModel[]>(`${this.baseUrl}/organization/${organizationId}/users`);
   }

  searchOrgUsers(searchParams: ClientSearchParams): Observable<UserProfileViewModel[]> {
       return this.http.post<UserProfileViewModel[]>(`${this.baseUrl}/organization/users/search`, searchParams)
            .pipe(map((result: UserProfileViewModel[]) => result));
  }

  getOrgLibraryUsers(): Observable<UserProfileViewModel[]> {
       return this.http.get<UserProfileViewModel[]>(`${this.baseUrl}/organization/usersLibrary`);
   }

  getOrganization(organizationId: number): Observable<OrganizationViewModelRead> {
       return this.http.get<OrganizationViewModelRead>(`${this.baseUrl}/organization/${organizationId}`);
   }

  getOrganizationAdminEmails(organizationId: number): Observable<string[]> {
       return this.http.get<string[]>(`${this.baseUrl}/organization/${organizationId}/adminEmails`);
   }

  getPricingTiers(): Observable<PricingTierViewModel> {
       return this.http.get<PricingTierViewModel>(`${this.baseUrl}/organizations/pricingTiers`);
   }

  updateOrganization(model: OrganizationViewModel): Observable<OrganizationViewModelRead> {
       return this.http.put<OrganizationViewModelRead>(`${this.baseUrl}/organization`, model)
            .pipe(map((result: OrganizationViewModelRead) => result));
  }

  addPaymentMethodAndCreateSubscription(model: CreatePaymentMethodViewModel): Observable<OrganizationBillingViewModel> {
       return this.http.post<OrganizationBillingViewModel>(`${this.baseUrl}/organization/addPaymentMethod`, model)
            .pipe(map((result: OrganizationBillingViewModel) => result));
  }

  createSubscriptionWithExistingCard(model: CreateSubscriptionViewModel): Observable<OrganizationBillingViewModel> {
       return this.http.post<OrganizationBillingViewModel>(`${this.baseUrl}/organization/createSubscription`, model)
            .pipe(map((result: OrganizationBillingViewModel) => result));
  }

  updatePaymentMethod(model: CreatePaymentMethodViewModel): Observable<OrganizationBillingViewModel> {
       return this.http.post<OrganizationBillingViewModel>(`${this.baseUrl}/organization/updatePaymentMethod`, model)
            .pipe(map((result: OrganizationBillingViewModel) => result));
  }

  getOrganizationBillingDetails(): Observable<OrganizationBillingViewModel> {
       return this.http.get<OrganizationBillingViewModel>(`${this.baseUrl}/organization/billing`);
   }

  getLogo(): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/organization/getLogo`);
   }

  addOrganization(model: CreateOrganizationViewModel): Observable<OrganizationListViewModelRead> {
       return this.http.post<OrganizationListViewModelRead>(`${this.baseUrl}/organization`, model)
            .pipe(map((result: OrganizationListViewModelRead) => result));
  }

  registerNewOrganization(model: OrganizationRegistrationViewModel): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/organization/register`, model)
            .pipe(map((result: StringViewModel) => result));
  }

  searchOrganizations(searchParams: OrganizationSearchParams): Observable<OrganizationListViewModelRead[]> {
       return this.http.post<OrganizationListViewModelRead[]>(`${this.baseUrl}/organizations/search`, searchParams)
            .pipe(map((result: OrganizationListViewModelRead[]) => result));
  }

  getInvoicesForOrganization(): Observable<OrganizationInvoiceViewModel[]> {
       return this.http.get<OrganizationInvoiceViewModel[]>(`${this.baseUrl}/organization/invoices`);
   }

  cancelSubscription(): Observable<OrganizationBillingViewModel> {
       return this.http.put<OrganizationBillingViewModel>(`${this.baseUrl}/organization/cancelSubscription`, null)
            .pipe(map((result: OrganizationBillingViewModel) => result));
  }

  reActivateExistingSubscription(): Observable<OrganizationBillingViewModel> {
       return this.http.put<OrganizationBillingViewModel>(`${this.baseUrl}/organization/reactivateSubscription`, null)
            .pipe(map((result: OrganizationBillingViewModel) => result));
  }

  retrieveSubscription(): Observable<OrganizationSubscriptionViewModel> {
       return this.http.get<OrganizationSubscriptionViewModel>(`${this.baseUrl}/organization/subscription`);
   }

  reinstateExpiredOrgByAdmin(): Observable<ReinstateOrgTrialViewModel> {
       return this.http.put<ReinstateOrgTrialViewModel>(`${this.baseUrl}/organization/reinstateTrial`, null)
            .pipe(map((result: ReinstateOrgTrialViewModel) => result));
  }

  isDongleIdDuplicate(organizationId: number, dongleId: string): Observable<boolean> {
       if (organizationId == null && dongleId == null){
       return this.http.get<boolean>(`${this.baseUrl}/organization/duplicateDongleId`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/organization/duplicateDongleId?organizationId=${organizationId}&dongleId=${dongleId}`);
   }
  }

  isMarketplaceURLSlugDuplicate(name: string): Observable<boolean> {
       if (name == null){
       return this.http.get<boolean>(`${this.baseUrl}/organization/duplicateMarketplaceURLSlug`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/organization/duplicateMarketplaceURLSlug?name=${name}`);
   }
  }

  getStripeConnectedAccountBalance(organizationId: number): Observable<StripeConnectedAccountBalanceViewModel> {
       return this.http.get<StripeConnectedAccountBalanceViewModel>(`${this.baseUrl}/organizations/${organizationId}/stripeConnectedAccount/balance`);
   }

  createConnectedAccountLink(organizationId: number): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/organizations/${organizationId}/stripeConnectedAccount/create`);
   }

  doesOrganizationHaveMarketplaceUsers(): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/organization/hasMarketplaceUsers`);
   }

  getPromoCodes(): Observable<PromoCodeViewModelRead[]> {
       return this.http.get<PromoCodeViewModelRead[]>(`${this.baseUrl}/organization/promoCodes`);
   }

  addUpdatePromoCodes(model: any[]): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/promoCodes`, model)
            .pipe(map((result: boolean) => result));
  }

  doesOrganizationRequestDailyStatus(): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/organization/requestsDailyStatus`);
   }

}
@Injectable()
export class PaidProgramService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getOrganizationByMarketplaceURLSlug(marketplaceURLSlug: string): Observable<OrganizationViewModelRead> {
       if (marketplaceURLSlug == null){
       return this.http.get<OrganizationViewModelRead>(`${this.baseUrl}/paidPrograms/organizationBySlug`);
   } else{
       return this.http.get<OrganizationViewModelRead>(`${this.baseUrl}/paidPrograms/organizationBySlug?marketplaceURLSlug=${marketplaceURLSlug}`);
   }
  }

  getProgramSummaryById(programId: number, organizationId: number): Observable<ProgramSummaryViewModelRead> {
       if (organizationId == null){
       return this.http.get<ProgramSummaryViewModelRead>(`${this.baseUrl}/paidPrograms/${programId}`);
   } else{
       return this.http.get<ProgramSummaryViewModelRead>(`${this.baseUrl}/paidPrograms/${programId}?organizationId=${organizationId}`);
   }
  }

  getProgramKeywordById(programKeywordId: number): Observable<ProgramKeywordViewModelRead> {
       return this.http.get<ProgramKeywordViewModelRead>(`${this.baseUrl}/paidPrograms/programKeywords/${programKeywordId}`);
   }

  getAuthorById(userId: number): Observable<UserSummaryViewModel> {
       return this.http.get<UserSummaryViewModel>(`${this.baseUrl}/paidPrograms/authors/${userId}`);
   }

  getProgramKeywordsForPaidProgramsByOrganization(organizationId: number): Observable<ProgramKeywordViewModelRead[]> {
       if (organizationId == null){
       return this.http.get<ProgramKeywordViewModelRead[]>(`${this.baseUrl}/paidPrograms/programKeywords`);
   } else{
       return this.http.get<ProgramKeywordViewModelRead[]>(`${this.baseUrl}/paidPrograms/programKeywords?organizationId=${organizationId}`);
   }
  }

  getProgramKeywordsForPaidProgramsByOrganizationAndAuthor(userId: number, organizationId: number): Observable<ProgramKeywordViewModelRead[]> {
       if (organizationId == null){
       return this.http.get<ProgramKeywordViewModelRead[]>(`${this.baseUrl}/paidPrograms/programKeywords/authors/${userId}`);
   } else{
       return this.http.get<ProgramKeywordViewModelRead[]>(`${this.baseUrl}/paidPrograms/programKeywords/authors/${userId}?organizationId=${organizationId}`);
   }
  }

  getAuthorsForPaidProgramsByOrganization(organizationId: number): Observable<UserSummaryViewModel[]> {
       if (organizationId == null){
       return this.http.get<UserSummaryViewModel[]>(`${this.baseUrl}/paidPrograms/authors`);
   } else{
       return this.http.get<UserSummaryViewModel[]>(`${this.baseUrl}/paidPrograms/authors?organizationId=${organizationId}`);
   }
  }

  getPaidProgramsByOrganizationAndKeyword(organizationId: number, programKeywordId: number, page: number, size: number, sortProperty: string, isSortDesc: boolean): Observable<PagedResult<ProgramListViewModelRead>> {
       if (organizationId == null && programKeywordId == null && page == null && size == null && sortProperty == null && isSortDesc == null){
       return this.http.get<PagedResult<ProgramListViewModelRead>>(`${this.baseUrl}/paidPrograms`);
   } else{
       return this.http.get<PagedResult<ProgramListViewModelRead>>(`${this.baseUrl}/paidPrograms?organizationId=${organizationId}&programKeywordId=${programKeywordId}&page=${page}&size=${size}&sortProperty=${sortProperty}&isSortDesc=${isSortDesc}`);
   }
  }

  getPaidProgramsByOrganizationAndAuthor(organizationId: number, userId: number, searchParams: ProgramSearchParams): Observable<PagedResult<ProgramListViewModelRead>> {
       if (organizationId == null && userId == null){
       return this.http.post<PagedResult<ProgramListViewModelRead>>(`${this.baseUrl}/paidPrograms/byAuthor`, searchParams)
            .pipe(map((result: PagedResult<ProgramListViewModelRead>) => result));
  } else{
       return this.http.post<PagedResult<ProgramListViewModelRead>>(`${this.baseUrl}/paidPrograms/byAuthor?organizationId=${organizationId}&userId=${userId}`, searchParams)
            .pipe(map((result: PagedResult<ProgramListViewModelRead>) => result));
  }
  }

  purchasePaidProgram(model: PurchasePaidProgramViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/paidPrograms/purchase`, model)
            .pipe(map((result: boolean) => result));
  }

  addNewPaidProgramClient(model: AddPaidProgramRunnerViewModel): Observable<ClientSummaryDTO> {
       return this.http.post<ClientSummaryDTO>(`${this.baseUrl}/paidPrograms/user`, model)
            .pipe(map((result: ClientSummaryDTO) => result));
  }

  addPaidProgramOrganizationToUserCredential(organizationId: number, coachUserId: number): Observable<ClientSummaryDTO> {
       if (organizationId == null && coachUserId == null){
       return this.http.post<ClientSummaryDTO>(`${this.baseUrl}/paidPrograms/userCredential`, null)
            .pipe(map((result: ClientSummaryDTO) => result));
  } else{
       return this.http.post<ClientSummaryDTO>(`${this.baseUrl}/paidPrograms/userCredential?organizationId=${organizationId}&coachUserId=${coachUserId}`, null)
            .pipe(map((result: ClientSummaryDTO) => result));
  }
  }

  getValidPromoCodeByCode(promoCode: string, organizationId: number, programId: number): Observable<PromoCodeViewModelRead> {
       if (promoCode == null && organizationId == null && programId == null){
       return this.http.get<PromoCodeViewModelRead>(`${this.baseUrl}/promoCodes/code`);
   } else{
       return this.http.get<PromoCodeViewModelRead>(`${this.baseUrl}/promoCodes/code?promoCode=${promoCode}&organizationId=${organizationId}&programId=${programId}`);
   }
  }

  getPurchasedProgramsByUser(userId: number): Observable<ProgramSummaryViewModelReadExtended[]> {
       return this.http.get<ProgramSummaryViewModelReadExtended[]>(`${this.baseUrl}/paidPrograms/purchasedPrograms/${userId}`);
   }

  searchGlobalPaidPrograms(searchParams: GlobalPaidProgramsSearchParams): Observable<PagedResult<GlobalMarketplaceProgramListViewModelRead>> {
       return this.http.post<PagedResult<GlobalMarketplaceProgramListViewModelRead>>(`${this.baseUrl}/paidPrograms/globalMarketplace/search`, searchParams)
            .pipe(map((result: PagedResult<GlobalMarketplaceProgramListViewModelRead>) => result));
  }

}
@Injectable()
export class ProgramsService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getProgramsForOrganization(page: number, size: number, sortProperty: string, isSortDesc: boolean): Observable<PagedResult<ProgramListViewModelRead>> {
       if (page == null && size == null && sortProperty == null && isSortDesc == null){
       return this.http.get<PagedResult<ProgramListViewModelRead>>(`${this.baseUrl}/programs`);
   } else{
       return this.http.get<PagedResult<ProgramListViewModelRead>>(`${this.baseUrl}/programs?page=${page}&size=${size}&sortProperty=${sortProperty}&isSortDesc=${isSortDesc}`);
   }
  }

  getAllProgramsForOrganization(): Observable<ProgramListViewModelRead[]> {
       return this.http.get<ProgramListViewModelRead[]>(`${this.baseUrl}/programs/all`);
   }

  searchForPrograms(searchParams: ProgramSearchParams): Observable<PagedResult<ProgramListViewModelRead>> {
       return this.http.post<PagedResult<ProgramListViewModelRead>>(`${this.baseUrl}/programs/search`, searchParams)
            .pipe(map((result: PagedResult<ProgramListViewModelRead>) => result));
  }

  getProgramById(programId: number, checkOrganizationId: boolean): Observable<ProgramViewModelRead> {
       if (checkOrganizationId == null){
       return this.http.get<ProgramViewModelRead>(`${this.baseUrl}/programs/${programId}`);
   } else{
       return this.http.get<ProgramViewModelRead>(`${this.baseUrl}/programs/${programId}?checkOrganizationId=${checkOrganizationId}`);
   }
  }

  getProgramKeywordsForOrganization(): Observable<ProgramKeywordViewModelRead[]> {
       return this.http.get<ProgramKeywordViewModelRead[]>(`${this.baseUrl}/programs/programKeywords`);
   }

  addProgram(model: ProgramViewModel): Observable<ProgramViewModelRead> {
       return this.http.post<ProgramViewModelRead>(`${this.baseUrl}/programs`, model)
            .pipe(map((result: ProgramViewModelRead) => result));
  }

  updateProgram(programId: number, model: ProgramViewModel): Observable<ProgramViewModelRead> {
       return this.http.put<ProgramViewModelRead>(`${this.baseUrl}/programs/${programId}`, model)
            .pipe(map((result: ProgramViewModelRead) => result));
  }

  deleteProgram(programId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/programs/${programId}`);
   }

  isProgramNameDuplicate(name: string, existingId: number): Observable<boolean> {
       if (name == null && existingId == null){
       return this.http.get<boolean>(`${this.baseUrl}/programs/duplicateName`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/programs/duplicateName?name=${name}&existingId=${existingId}`);
   }
  }

  assignProgramToClient(model: ProgramAssignmentViewModel): Observable<ClientProgramViewModelRead> {
       return this.http.post<ClientProgramViewModelRead>(`${this.baseUrl}/programs/clients`, model)
            .pipe(map((result: ClientProgramViewModelRead) => result));
  }

  assignSurveyProgramsToClient(model: any[]): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/programs/clients/assignSurveyPrograms`, model)
            .pipe(map((result: boolean) => result));
  }

  assignProgramToTeam(model: ProgramTeamAssignmentViewModel): Observable<TeamProgramViewModelRead> {
       return this.http.post<TeamProgramViewModelRead>(`${this.baseUrl}/programs/teams`, model)
            .pipe(map((result: TeamProgramViewModelRead) => result));
  }

  assignAssessmentProgramsToClient(model: AssessmentProgramAssignmentViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/programs/clients/assessmentPrograms`, model)
            .pipe(map((result: boolean) => result));
  }

  getClientProgramById(clientProgramId: number): Observable<ClientProgramViewModelRead> {
       return this.http.get<ClientProgramViewModelRead>(`${this.baseUrl}/programs/clients/${clientProgramId}`);
   }

  cloneProgram(userId: number, programId: number): Observable<ProgramViewModelRead> {
       if (userId == null && programId == null){
       return this.http.post<ProgramViewModelRead>(`${this.baseUrl}/programs/clone`, null)
            .pipe(map((result: ProgramViewModelRead) => result));
  } else{
       return this.http.post<ProgramViewModelRead>(`${this.baseUrl}/programs/clone?userId=${userId}&programId=${programId}`, null)
            .pipe(map((result: ProgramViewModelRead) => result));
  }
  }

  getMovementCategoryPrograms(): Observable<MovementCategoryProgramViewModelRead[]> {
       return this.http.get<MovementCategoryProgramViewModelRead[]>(`${this.baseUrl}/programs/movementCategory`);
   }

  getImpairmentCategoryPrograms(): Observable<ImpairmentCategoryProgramViewModelRead[]> {
       return this.http.get<ImpairmentCategoryProgramViewModelRead[]>(`${this.baseUrl}/programs/impairmentCategory`);
   }

  addUpdateMovementCategoryPrograms(model: any[]): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/programs/movementCategory`, model)
            .pipe(map((result: boolean) => result));
  }

  addUpdateImpairmentCategoryPrograms(model: any[]): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/programs/impairmentCategory`, model)
            .pipe(map((result: boolean) => result));
  }

  getLoadingLevelsPrograms(): Observable<LoadingLevelsProgramViewModelRead[]> {
       return this.http.get<LoadingLevelsProgramViewModelRead[]>(`${this.baseUrl}/programs/loadingLevels`);
   }

  updateLoadingLevelsPrograms(model: any[]): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/programs/loadingLevels`, model)
            .pipe(map((result: boolean) => result));
  }

  assignLoadingLevelsAssessmentProgramsToClient(model: LoadingLevelsProgramAssignmentViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/programs/clients/loadingLevelsAssessmentPrograms`, model)
            .pipe(map((result: boolean) => result));
  }

  assignTwoDimensionalAssessmentProgramsToClient(model: TwoDimensionalProgramAssignmentViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/programs/clients/twoDimensionalAssessmentPrograms`, model)
            .pipe(map((result: boolean) => result));
  }

  assignCurrentImpairmentCategoryProgramToClient(model: ImpairmentCategoryUpdateViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/programs/clients/impairmentCategoryProgram`, model)
            .pipe(map((result: boolean) => result));
  }

}
@Injectable()
export class ReportsService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getCoachAthleteGroups(): Observable<CoachAthleteGroupViewModel[]> {
       return this.http.get<CoachAthleteGroupViewModel[]>(`${this.baseUrl}/reports/coachAthleteGroup`);
   }

  getCompletionPercentageReport(filter: DynamicReportFilterViewModel): Observable<DynamicReportViewModel> {
       return this.http.put<DynamicReportViewModel>(`${this.baseUrl}/reports/completionPercentageReport`, filter)
            .pipe(map((result: DynamicReportViewModel) => result));
  }

  getTrainingVolumeReport(filter: DynamicReportFilterViewModel): Observable<TrainingVolumeReportViewModel> {
       return this.http.put<TrainingVolumeReportViewModel>(`${this.baseUrl}/reports/trainingVolumeReport`, filter)
            .pipe(map((result: TrainingVolumeReportViewModel) => result));
  }

  getRPEIntensityTrainingVolumeChart(clientUserId: number, page: number, localCurrentDate: Date): Observable<ChartViewModel> {
       if (page == null && localCurrentDate == null){
       return this.http.get<ChartViewModel>(`${this.baseUrl}/reports/intensityRPE/clients/${clientUserId}/chart`);
   } else{
       return this.http.get<ChartViewModel>(`${this.baseUrl}/reports/intensityRPE/clients/${clientUserId}/chart?page=${page}&localCurrentDate=${localCurrentDate.toISOString()}`);
   }
  }

  getCurrentWeekTrainingLoadTargetData(clientUserId: number, localCurrentDate: Date): Observable<TrainingLoadTargetViewModelRead> {
       if (localCurrentDate == null){
       return this.http.get<TrainingLoadTargetViewModelRead>(`${this.baseUrl}/reports/clients/${clientUserId}/trainingLoadTargetData`);
   } else{
       return this.http.get<TrainingLoadTargetViewModelRead>(`${this.baseUrl}/reports/clients/${clientUserId}/trainingLoadTargetData?localCurrentDate=${localCurrentDate.toISOString()}`);
   }
  }

  getCoachDashboardData(filter: DynamicReportFilterViewModel): Observable<CoachDashboardViewModel> {
       return this.http.put<CoachDashboardViewModel>(`${this.baseUrl}/reports/coachDashboard`, filter)
            .pipe(map((result: CoachDashboardViewModel) => result));
  }

  getACWRHistoryForClient(clientUserId: number, page: number, size: number): Observable<PagedResult<AcuteChronicHistoryViewModel>> {
       if (page == null && size == null){
       return this.http.get<PagedResult<AcuteChronicHistoryViewModel>>(`${this.baseUrl}/reports/clients/${clientUserId}/acuteChronicHistory`);
   } else{
       return this.http.get<PagedResult<AcuteChronicHistoryViewModel>>(`${this.baseUrl}/reports/clients/${clientUserId}/acuteChronicHistory?page=${page}&size=${size}`);
   }
  }

  getACWRByActivityTypeForUser(clientUserId: number): Observable<UserCredentialStatIntensityByActivityTypeViewModelRead> {
       return this.http.get<UserCredentialStatIntensityByActivityTypeViewModelRead>(`${this.baseUrl}/reports/clients/${clientUserId}/acuteChronicByActivity`);
   }

  rebuildReportingTablesForUserCredential(clientUserCredentialId: number, startDate: Date): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/reports/userCredentials/${clientUserCredentialId}/rebuild`, startDate)
            .pipe(map((result: boolean) => result));
  }

}
@Injectable()
export class StravaService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  deauthorizeStravaAccount(): Observable<StravaDeauthorizeResponse> {
       return this.http.post<StravaDeauthorizeResponse>(`${this.baseUrl}/strava/deauthorize`, null)
            .pipe(map((result: StravaDeauthorizeResponse) => result));
  }

}
@Injectable()
export class TeamService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getAllTeamsForOrganization(): Observable<TeamListViewModelRead[]> {
       return this.http.get<TeamListViewModelRead[]>(`${this.baseUrl}/teams`);
   }

  getTeamsSummaryForOrganizationWithPermissions(): Observable<TeamSummaryViewModelRead[]> {
       return this.http.get<TeamSummaryViewModelRead[]>(`${this.baseUrl}/teams/summary`);
   }

  getTeamById(teamId: number): Observable<TeamListViewModelRead> {
       return this.http.get<TeamListViewModelRead>(`${this.baseUrl}/teams/${teamId}`);
   }

  getTeamSummaryByIdWithPermissions(teamId: number): Observable<TeamSummaryViewModelRead> {
       return this.http.get<TeamSummaryViewModelRead>(`${this.baseUrl}/teams/${teamId}/summary`);
   }

  getTeamDetailsById(teamId: number): Observable<TeamDetailsViewModelRead> {
       return this.http.get<TeamDetailsViewModelRead>(`${this.baseUrl}/teams/${teamId}/details`);
   }

  addTeam(model: TeamAddViewModel): Observable<TeamDetailsViewModelRead> {
       return this.http.post<TeamDetailsViewModelRead>(`${this.baseUrl}/teams`, model)
            .pipe(map((result: TeamDetailsViewModelRead) => result));
  }

  updateTeam(teamId: number, model: TeamEditViewModel): Observable<TeamDetailsViewModelRead> {
       return this.http.put<TeamDetailsViewModelRead>(`${this.baseUrl}/teams/${teamId}`, model)
            .pipe(map((result: TeamDetailsViewModelRead) => result));
  }

  deleteTeam(teamId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/teams/${teamId}`);
   }

  isTeamNameDuplicate(name: string, existingId: number): Observable<boolean> {
       if (name == null && existingId == null){
       return this.http.get<boolean>(`${this.baseUrl}/team/duplicateName`);
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/team/duplicateName?name=${name}&existingId=${existingId}`);
   }
  }

  deleteRoleFromTeamUser(teamId: number, userId: number, role: TeamUserRole): Observable<boolean> {
       if (role == null){
       return this.http.delete<boolean>(`${this.baseUrl}/teams/${teamId}/users/${userId}/role`);
   } else{
       return this.http.delete<boolean>(`${this.baseUrl}/teams/${teamId}/users/${userId}/role?role=${role}`);
   }
  }

  getTeamCalendarWeeks(teamId: number, selectedDate: Date, localCurrentDate: Date, isMonthView: boolean): Observable<CalendarWeekViewModel[]> {
       if (selectedDate == null && localCurrentDate == null && isMonthView == null){
       return this.http.get<CalendarWeekViewModel[]>(`${this.baseUrl}/teams/${teamId}/calendarWeeks`);
   } else{
       return this.http.get<CalendarWeekViewModel[]>(`${this.baseUrl}/teams/${teamId}/calendarWeeks?selectedDate=${selectedDate.toISOString()}&localCurrentDate=${localCurrentDate.toISOString()}&isMonthView=${isMonthView}`);
   }
  }

  getTeamCalendarDaysByDateRange(teamId: number, startDate: Date, endDate: Date): Observable<CalendarDayViewModel[]> {
       if (startDate == null && endDate == null){
       return this.http.get<CalendarDayViewModel[]>(`${this.baseUrl}/teams/${teamId}/calendarDays`);
   } else{
       return this.http.get<CalendarDayViewModel[]>(`${this.baseUrl}/teams/${teamId}/calendarDays?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`);
   }
  }

  addTeamProgramWorkoutDay(teamId: number, model: TeamProgramWorkoutDayViewModel): Observable<TeamProgramWorkoutDayViewModelRead> {
       return this.http.post<TeamProgramWorkoutDayViewModelRead>(`${this.baseUrl}/teams/${teamId}/workoutDays`, model)
            .pipe(map((result: TeamProgramWorkoutDayViewModelRead) => result));
  }

  updateTeamProgramWorkoutDay(teamId: number, workoutDayId: number, model: TeamProgramWorkoutDayViewModel): Observable<TeamProgramWorkoutDayViewModelRead> {
       return this.http.put<TeamProgramWorkoutDayViewModelRead>(`${this.baseUrl}/teams/${teamId}/workoutDays/${workoutDayId}`, model)
            .pipe(map((result: TeamProgramWorkoutDayViewModelRead) => result));
  }

  updateTeamProgramWorkoutDayOccurrence(workoutDayId: number, model: TeamProgramWorkoutDayEditViewModel): Observable<TeamProgramWorkoutDayViewModelRead> {
       return this.http.put<TeamProgramWorkoutDayViewModelRead>(`${this.baseUrl}/teams/workoutDays/${workoutDayId}/editOccurrence`, model)
            .pipe(map((result: TeamProgramWorkoutDayViewModelRead) => result));
  }

  deleteTeamProgramWorkoutDay(teamId: number, workoutDayId: number, deleteSeries: boolean): Observable<boolean> {
       if (deleteSeries == null){
       return this.http.delete<boolean>(`${this.baseUrl}/teams/${teamId}/workoutDays/${workoutDayId}`);
   } else{
       return this.http.delete<boolean>(`${this.baseUrl}/teams/${teamId}/workoutDays/${workoutDayId}?deleteSeries=${deleteSeries}`);
   }
  }

  deleteTeamProgram(teamId: number, teamProgramId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/teams/${teamId}/programs/${teamProgramId}`);
   }

  getTeamDashboardData(teamId: number): Observable<TeamDashboardViewModel> {
       return this.http.get<TeamDashboardViewModel>(`${this.baseUrl}/teams/${teamId}/dashboard`);
   }

  getCurrentProgramsForTeam(teamId: number): Observable<TeamProgramListViewModel[]> {
       return this.http.get<TeamProgramListViewModel[]>(`${this.baseUrl}/teams/${teamId}/currentPrograms`);
   }

  copyTeamCalendarWeek(teamId: number, model: CopyCalendarWeekViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/teams/${teamId}/copyCalendarWeek`, model)
            .pipe(map((result: boolean) => result));
  }

}
@Injectable()
export class TermsAndConditionsService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getLatestTermsAndConditions(): Observable<TermsAndConditionsViewModelRead> {
       return this.http.get<TermsAndConditionsViewModelRead>(`${this.baseUrl}/termsAndConditions`);
   }

}
@Injectable()
export class UserService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getUserAuthProfile(): Observable<UserAuthProfileViewModel> {
       return this.http.get<UserAuthProfileViewModel>(`${this.baseUrl}/users/authProfile`);
   }

  getProfile(): Observable<UserProfileViewModel> {
       return this.http.get<UserProfileViewModel>(`${this.baseUrl}/users/profile`);
   }

  getProfileById(userId: number): Observable<UserProfileViewModel> {
       return this.http.get<UserProfileViewModel>(`${this.baseUrl}/users/${userId}/profile`);
   }

  updateProfile(userId: number, model: UpdateProfileViewModel): Observable<UserProfileViewModel> {
       return this.http.post<UserProfileViewModel>(`${this.baseUrl}/users/${userId}/updateProfile`, model)
            .pipe(map((result: UserProfileViewModel) => result));
  }

  completeRegistration(model: UpdateProfileWithPasswordViewModel): Observable<UserProfileViewModel> {
       return this.http.post<UserProfileViewModel>(`${this.baseUrl}/users/completeRegistration`, model)
            .pipe(map((result: UserProfileViewModel) => result));
  }

  lookupByEmail(model: UserLookupInputViewModel): Observable<UserLookupViewModel> {
       return this.http.post<UserLookupViewModel>(`${this.baseUrl}/users/lookupByEmail`, model)
            .pipe(map((result: UserLookupViewModel) => result));
  }

  isEmailDuplicate(email: string, existingUserId: number): Observable<boolean> {
       if (email == null && existingUserId == null){
       return this.http.get<boolean>(`${this.baseUrl}/users/duplicateEmail`).pipe(debounceTime(500));
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/users/duplicateEmail?email=${email}&existingUserId=${existingUserId}`).pipe(debounceTime(500));
   }
  }

  isEmailDuplicateInOrg(email: string, existingUserId: number): Observable<boolean> {
       if (email == null && existingUserId == null){
       return this.http.get<boolean>(`${this.baseUrl}/users/duplicateEmailInOrg`).pipe(debounceTime(500));
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/users/duplicateEmailInOrg?email=${email}&existingUserId=${existingUserId}`).pipe(debounceTime(500));
   }
  }

  doesEmailExistInOtherOrganization(email: string): Observable<boolean> {
       if (email == null){
       return this.http.get<boolean>(`${this.baseUrl}/users/existsInOtherOrg`).pipe(debounceTime(500));
   } else{
       return this.http.get<boolean>(`${this.baseUrl}/users/existsInOtherOrg?email=${email}`).pipe(debounceTime(500));
   }
  }

  changePassword(userDto: ChangePasswordViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/changePassword`, userDto)
            .pipe(map((result: boolean) => result));
  }

  initiatePasswordReset(model: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/initatePasswordReset`, model)
            .pipe(map((result: boolean) => result));
  }

  resetPassword(model: ResetPasswordViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/resetPassword`, model)
            .pipe(map((result: boolean) => result));
  }

  getImageAsBase64(userId: number): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/users${userId}/getAvatar`);
   }

  sendEmailVerification(): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/emailverification`, null)
            .pipe(map((result: boolean) => result));
  }

  createNewUser(model: AddUserViewModel): Observable<UserProfileViewModel> {
       return this.http.post<UserProfileViewModel>(`${this.baseUrl}/users`, model)
            .pipe(map((result: UserProfileViewModel) => result));
  }

  createNewUserForSpecifiedOrg(organizationId: number, model: AddUserViewModel): Observable<UserProfileViewModel> {
       return this.http.post<UserProfileViewModel>(`${this.baseUrl}/organizations/${organizationId}/users`, model)
            .pipe(map((result: UserProfileViewModel) => result));
  }

  deactivateUser(userId: number, coachUserId: number): Observable<boolean> {
       if (coachUserId == null){
       return this.http.post<boolean>(`${this.baseUrl}/users/${userId}/deactivate`, null)
            .pipe(map((result: boolean) => result));
  } else{
       return this.http.post<boolean>(`${this.baseUrl}/users/${userId}/deactivate?coachUserId=${coachUserId}`, null)
            .pipe(map((result: boolean) => result));
  }
  }

  activateUser(userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/${userId}/activate`, null)
            .pipe(map((result: boolean) => result));
  }

  updateUser(userId: number, model: UpdateUserViewModel): Observable<UserProfileViewModel> {
       return this.http.post<UserProfileViewModel>(`${this.baseUrl}/users/${userId}/updateUser`, model)
            .pipe(map((result: UserProfileViewModel) => result));
  }

  updateUserRole(userId: number, model: UpdateUserRoleViewModel): Observable<UserProfileViewModel> {
       return this.http.post<UserProfileViewModel>(`${this.baseUrl}/users/${userId}/userRole`, model)
            .pipe(map((result: UserProfileViewModel) => result));
  }

  acceptInvitation(): Observable<UserProfileViewModel> {
       return this.http.post<UserProfileViewModel>(`${this.baseUrl}/users/acceptInvitation`, null)
            .pipe(map((result: UserProfileViewModel) => result));
  }

  deleteInvitedUser(userId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/users/${userId}/deleteInvitation`);
   }

  resendCoachWelcomeEmail(userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/${userId}/resendCoachWelcomeEmail`, null)
            .pipe(map((result: boolean) => result));
  }

  updateExcludeGPSData(userCredentialId: number, model: BooleanViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/userCredentials/${userCredentialId}/excludeGPSData`, model)
            .pipe(map((result: boolean) => result));
  }

  updateUserCredentialTermsAndConditionsVersion(userCredentialId: number, termsAndConditionsVersion: number): Observable<boolean> {
       if (termsAndConditionsVersion == null){
       return this.http.post<boolean>(`${this.baseUrl}/users/userCredentials/${userCredentialId}`, null)
            .pipe(map((result: boolean) => result));
  } else{
       return this.http.post<boolean>(`${this.baseUrl}/users/userCredentials/${userCredentialId}?termsAndConditionsVersion=${termsAndConditionsVersion}`, null)
            .pipe(map((result: boolean) => result));
  }
  }

  isUserOnlyAthleteAndAdminInOrg(): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/users/isOnlyAthleteAndAdmin`);
   }

}
@Injectable()
export class VideoService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getSASForVideoContainer(model: StringViewModel): Observable<AzureBlobSASViewModel> {
       return this.http.post<AzureBlobSASViewModel>(`${this.baseUrl}/videos/upload-sas`, model)
            .pipe(map((result: AzureBlobSASViewModel) => result));
  }

  addVideo(model: VideoViewModel): Observable<VideoViewModelRead> {
       return this.http.post<VideoViewModelRead>(`${this.baseUrl}/videos`, model)
            .pipe(map((result: VideoViewModelRead) => result));
  }

  getVideoById(videoId: number): Observable<VideoViewModelRead> {
       return this.http.get<VideoViewModelRead>(`${this.baseUrl}/videos/${videoId}`);
   }

}
@Injectable()
export class NotificationsService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getUserCredentialNotifications(): Observable<UserCredentialNotificationViewModelRead[]> {
       return this.http.get<UserCredentialNotificationViewModelRead[]>(`${this.baseUrl}/notifications/userCredentials`);
   }

  getUserCredentialNotificationTypes(): Observable<NotificationTypeRoleViewModelRead[]> {
       return this.http.get<NotificationTypeRoleViewModelRead[]>(`${this.baseUrl}/notifications/notificationTypes/userCredentials`);
   }

  saveNotificationsForUserCredential(notifications: any[]): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/notifications/userCredentials`, notifications)
            .pipe(map((result: boolean) => result));
  }

}
@Injectable()
export class RacePlanService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getRacePlanById(userId: number, racePlanId: number): Observable<RacePlanViewModelRead> {
       return this.http.get<RacePlanViewModelRead>(`${this.baseUrl}/users/${userId}/racePlans/${racePlanId}`);
   }

  getRacePlansByUser(userId: number): Observable<RacePlanListViewModelRead[]> {
       return this.http.get<RacePlanListViewModelRead[]>(`${this.baseUrl}/users/${userId}/racePlans`);
   }

  createRacePlan(userId: number, model: RacePlanViewModel): Observable<RacePlanViewModelRead> {
       return this.http.post<RacePlanViewModelRead>(`${this.baseUrl}/users/${userId}/racePlans`, model)
            .pipe(map((result: RacePlanViewModelRead) => result));
  }

  updateRacePlan(racePlanId: number, model: RacePlanViewModel): Observable<RacePlanViewModelRead> {
       return this.http.put<RacePlanViewModelRead>(`${this.baseUrl}/racePlans/${racePlanId}`, model)
            .pipe(map((result: RacePlanViewModelRead) => result));
  }

  cloneRacePlan(racePlanId: number, newUserId: number): Observable<RacePlanViewModelRead> {
       if (newUserId == null){
       return this.http.post<RacePlanViewModelRead>(`${this.baseUrl}/racePlans/${racePlanId}/clone`, null)
            .pipe(map((result: RacePlanViewModelRead) => result));
  } else{
       return this.http.post<RacePlanViewModelRead>(`${this.baseUrl}/racePlans/${racePlanId}/clone?newUserId=${newUserId}`, null)
            .pipe(map((result: RacePlanViewModelRead) => result));
  }
  }

  deleteRacePlan(userId: number, racePlanId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/users/${userId}/racePlans/${racePlanId}`);
   }

}
@Injectable()
export class SuperUserService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  updateOrganization(organizationId: number, model: OrganizationViewModel): Observable<OrganizationViewModelRead> {
       return this.http.put<OrganizationViewModelRead>(`${this.baseUrl}/superuser/organization/${organizationId}`, model)
            .pipe(map((result: OrganizationViewModelRead) => result));
  }

  impersonateUser(userId: number): Observable<UserAuthenticationViewModel> {
       return this.http.post<UserAuthenticationViewModel>(`${this.baseUrl}/superuser/users/${userId}/impersonateUser`, null)
            .pipe(map((result: UserAuthenticationViewModel) => result));
  }

  searchAllUsers(searchParams: UserSearchParams): Observable<PagedResult<UserSearchResultViewModel>> {
       return this.http.post<PagedResult<UserSearchResultViewModel>>(`${this.baseUrl}/users/search`, searchParams)
            .pipe(map((result: PagedResult<UserSearchResultViewModel>) => result));
  }

  getSuperuserStats(): Observable<SuperuserStatsViewModel> {
       return this.http.get<SuperuserStatsViewModel>(`${this.baseUrl}/superuser/organizations/stats`);
   }

  getAllGlobalPrograms(): Observable<ProgramListViewModelRead[]> {
       return this.http.get<ProgramListViewModelRead[]>(`${this.baseUrl}/superuser/programs/global`);
   }

  getUserCountPerOrgByMonth(): Observable<SimpleDynamicReportViewModel> {
       return this.http.get<SimpleDynamicReportViewModel>(`${this.baseUrl}/superuser/organizations/userOrgCount`);
   }

}
@Injectable()
export class SurveyService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getAllSurveysWithDetails(): Observable<SurveyViewModelRead[]> {
       return this.http.get<SurveyViewModelRead[]>(`${this.baseUrl}/surveys/all`);
   }

  getActiveSurveys(): Observable<SurveySummaryViewModelRead[]> {
       return this.http.get<SurveySummaryViewModelRead[]>(`${this.baseUrl}/surveys`);
   }

  getSurveyById(surveyId: number): Observable<SurveyViewModelRead> {
       return this.http.get<SurveyViewModelRead>(`${this.baseUrl}/surveys/${surveyId}`);
   }

  getSurveySummaryById(surveyId: number): Observable<SurveySummaryViewModelRead> {
       return this.http.get<SurveySummaryViewModelRead>(`${this.baseUrl}/surveys/${surveyId}/summary`);
   }

  getSurveyQuestionSummaryById(surveyQuestionId: number): Observable<SurveyQuestionSummaryViewModelRead> {
       return this.http.get<SurveyQuestionSummaryViewModelRead>(`${this.baseUrl}/surveys/surveyQuestions/${surveyQuestionId}`);
   }

  getSurveyResultById(surveyResultId: number): Observable<SurveyResultViewModelRead> {
       return this.http.get<SurveyResultViewModelRead>(`${this.baseUrl}/surveys/surveyResults/${surveyResultId}`);
   }

  searchSurveyResultSummaries(searchParams: SurveyResultSearchParams): Observable<PagedResult<SurveyResultSummaryViewModelRead>> {
       return this.http.post<PagedResult<SurveyResultSummaryViewModelRead>>(`${this.baseUrl}/surveys/surveyResults/summary`, searchParams)
            .pipe(map((result: PagedResult<SurveyResultSummaryViewModelRead>) => result));
  }

  updateSurvey(surveyId: number, model: SurveySummaryViewModel): Observable<SurveySummaryViewModelRead> {
       return this.http.put<SurveySummaryViewModelRead>(`${this.baseUrl}/surveys/${surveyId}`, model)
            .pipe(map((result: SurveySummaryViewModelRead) => result));
  }

  updateSurveyQuestion(surveyQuestionId: number, model: SurveyQuestionSummaryViewModel): Observable<SurveyQuestionSummaryViewModelRead> {
       return this.http.put<SurveyQuestionSummaryViewModelRead>(`${this.baseUrl}/surveys/surveyQuestions/${surveyQuestionId}`, model)
            .pipe(map((result: SurveyQuestionSummaryViewModelRead) => result));
  }

  createSurveyResponse(model: SurveyResponseViewModel): Observable<SurveyResultViewModelRead> {
       return this.http.post<SurveyResultViewModelRead>(`${this.baseUrl}/surveys/surveyResponses`, model)
            .pipe(map((result: SurveyResultViewModelRead) => result));
  }

  updateSurveyResult(surveyResultId: number, model: SurveyResultViewModel): Observable<SurveyResultSummaryViewModelRead> {
       return this.http.put<SurveyResultSummaryViewModelRead>(`${this.baseUrl}/surveys/surveyResults/${surveyResultId}`, model)
            .pipe(map((result: SurveyResultSummaryViewModelRead) => result));
  }

  getSurveyResultFromSurveyResponse(model: SurveyResponseViewModel): Observable<SurveyResultViewModelRead> {
       return this.http.post<SurveyResultViewModelRead>(`${this.baseUrl}/surveys/surveyResults/fromResponse`, model)
            .pipe(map((result: SurveyResultViewModelRead) => result));
  }

}
@Injectable()
export class TrainingLoadPlannerService {
  private baseUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
  }

  getTrainingLoadPlanById(userId: number, trainingLoadPlannerId: number): Observable<TrainingLoadPlannerViewModelRead> {
       return this.http.get<TrainingLoadPlannerViewModelRead>(`${this.baseUrl}/planner/users/${userId}/trainingLoadPlanners/${trainingLoadPlannerId}`);
   }

  getTrainingLoadPlansByUser(userId: number): Observable<TrainingLoadPlannerListViewModelRead[]> {
       return this.http.get<TrainingLoadPlannerListViewModelRead[]>(`${this.baseUrl}/planner/users/${userId}`);
   }

  getTrainingLoadPeriods(): Observable<TrainingLoadPeriodViewModelRead[]> {
       return this.http.get<TrainingLoadPeriodViewModelRead[]>(`${this.baseUrl}/planner/periods`);
   }

  createTrainingLoadPlan(userId: number, model: TrainingLoadPlannerViewModel): Observable<TrainingLoadPlannerViewModelRead> {
       return this.http.post<TrainingLoadPlannerViewModelRead>(`${this.baseUrl}/planner/users/${userId}/trainingLoadPlan`, model)
            .pipe(map((result: TrainingLoadPlannerViewModelRead) => result));
  }

  updateTrainingLoadPlan(trainingLoadPlannerId: number, model: TrainingLoadPlannerViewModel): Observable<TrainingLoadPlannerViewModelRead> {
       return this.http.put<TrainingLoadPlannerViewModelRead>(`${this.baseUrl}/planner/${trainingLoadPlannerId}`, model)
            .pipe(map((result: TrainingLoadPlannerViewModelRead) => result));
  }

  cloneTrainingLoadPlan(trainingLoadPlannerId: number, newUserId: number): Observable<TrainingLoadPlannerViewModelRead> {
       if (newUserId == null){
       return this.http.post<TrainingLoadPlannerViewModelRead>(`${this.baseUrl}/planner/${trainingLoadPlannerId}/clone`, null)
            .pipe(map((result: TrainingLoadPlannerViewModelRead) => result));
  } else{
       return this.http.post<TrainingLoadPlannerViewModelRead>(`${this.baseUrl}/planner/${trainingLoadPlannerId}/clone?newUserId=${newUserId}`, null)
            .pipe(map((result: TrainingLoadPlannerViewModelRead) => result));
  }
  }

  deleteTrainingLoadPlan(userId: number, trainingLoadPlannerId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/planner/users/${userId}/trainingLoadPlanners/${trainingLoadPlannerId}`);
   }

}
